import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _ from 'lodash';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread';
import React from 'react';
import { Navigation } from '@janus.team/janus-particles';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { NavLink } from 'react-router-dom';
import crypto from 'crypto';
import { Tooltip } from 'react-tippy';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { Menu, Transition } from '@headlessui/react';
import { BsChevronDown, BsList, BsPersonCircle, BsThreeDots, BsBoxArrowUpRight } from 'react-icons/bs';
import safeStringify from 'fast-safe-stringify';
import VError from 'verror';
import { v4 } from 'uuid';
import cookies from 'js-cookie';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import * as defaultSentry from '@sentry/browser';
import _toArray from '@babel/runtime/helpers/esm/toArray';
import qs from 'qs';

var links = function links(catalog, navigationType) {
  return _.get(catalog, "catalog.".concat(navigationType, "Navigation.links")) || [];
};
var linksForArea = function linksForArea(catalog, navigationType, area) {
  return _.filter(links(catalog, navigationType), function (link) {
    return !area || (link.area || 'left') === area;
  });
};
var contextFrom = function contextFrom(catalog) {
  return _.merge({
    rackspaceAccountNumber: '',
    rackspaceAccountName: '',
    masterPayerAwsAccountNumber: '',
    masterPayerAwsAccountName: ''
  }, _.get(catalog, 'catalog.context'));
};
var userFrom = function userFrom(catalog) {
  return _.merge({
    firstName: '',
    lastName: '',
    userId: '',
    type: '',
    username: ''
  }, _.get(catalog, 'catalog.user'));
};

var labelFrom = function labelFrom(catalog) {
  return _.values(_.pick(userFrom(catalog), ['firstName', 'lastName'])).join(' ');
};

var asDropdown = function asDropdown(link, catalog) {
  return _.merge({}, link, {
    type: 'dropdown',
    label: labelFrom(catalog)
  });
};

var CurrentUser = function CurrentUser(_ref) {
  var link = _ref.link,
      navigationType = _ref.navigationType,
      catalog = _ref.catalog,
      Handler = _ref.Handler;
  return _.thru(asDropdown(link, catalog), function (target) {
    return React.createElement(Handler, {
      link: target,
      catalog: catalog,
      navigationType: navigationType
    });
  });
};
CurrentUser.displayName = 'CurrentUser';

var htmlPropsFor = function htmlPropsFor(link, navigationType, Handler) {
  var catalog = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    caret: true,
    action: _.get(link, 'label', '<missing link label>'),
    active: !!_.get(link, 'active'),
    children: _.thru(linksForArea(catalog, navigationType, link.rel), function (children) {
      return _.map(children, function (child) {
        return React.createElement(Handler, {
          key: child.rel,
          link: child,
          navigationType: navigationType,
          catalog: catalog
        });
      });
    })
  };
};

var hasVisibleChildren = function hasVisibleChildren(catalog, navigationType, link) {
  return _.some(linksForArea(catalog, navigationType, link.rel), function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref.type,
        rel = _ref.rel,
        hidden = _ref.hidden;

    return !hidden && (type !== 'dropdown-group' || hasVisibleChildren(catalog, navigationType, {
      rel: rel
    }));
  });
};

var Empty = function Empty() {
  return null;
};

var Dropdown = function Dropdown(_ref2) {
  var link = _ref2.link,
      navigationType = _ref2.navigationType,
      Handler = _ref2.Handler,
      catalog = _ref2.catalog;
  return hasVisibleChildren(catalog, navigationType, link) ? React.createElement(Navigation.Dropdown, _extends({
    utility: true
  }, htmlPropsFor(link, navigationType, Handler, catalog))) : React.createElement(Empty, null);
};
Dropdown.displayName = 'Dropdown';

var shouldShowHeader = function shouldShowHeader(header, links$$1) {
  return header && _.some(links$$1) && _.trim(header);
};

var hasVisibleLinks = function hasVisibleLinks(links$$1) {
  return _.some(links$$1, function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        hidden = _ref.hidden;

    return !hidden;
  });
};

var htmlPropsFor$1 = function htmlPropsFor(link, navigationType, Handler) {
  var catalog = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    children: _.thru(linksForArea(catalog, navigationType, link.rel), function (groupLinks) {
      return hasVisibleLinks(groupLinks) ? [].concat(_toConsumableArray(shouldShowHeader(link.label, groupLinks) ? [React.createElement(Navigation.Dropdown.Group.Header, {
        key: "header"
      }, link.label)] : []), _toConsumableArray(_.map(groupLinks, function (groupLink) {
        return React.createElement(Handler, {
          key: groupLink.rel,
          link: groupLink,
          catalog: catalog
        });
      }))) : [];
    })
  };
};

var DropdownGroup = function DropdownGroup(_ref2) {
  var link = _ref2.link,
      catalog = _ref2.catalog,
      getItemProps = _ref2.getItemProps,
      navigationType = _ref2.navigationType,
      Handler = _ref2.Handler;
  return _.thru(htmlPropsFor$1(link, navigationType, Handler, catalog), function (_ref3) {
    var children = _ref3.children,
        props = _objectWithoutProperties(_ref3, ["children"]);

    return _.some(children) ? React.createElement(Navigation.Dropdown.Group, _extends({
      children: children,
      getItemProps: getItemProps
    }, props)) : null;
  });
};
DropdownGroup.displayName = 'DropdownGroup';

var warned = {};
var warn = function warn() {
  var _console;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var key = _.join(_.compact(_.concat(args)), '-');

  if (warned[key]) {
    return;
  } // eslint-disable-next-line no-console


  (_console = console).warn.apply(_console, args);

  warned[key] = true;
}; // eslint-disable-next-line no-console

var error = function error() {
  var _console2;

  return (_console2 = console).error.apply(_console2, arguments);
}; // eslint-disable-next-line no-console

var context = {
  menu: React.createContext({}),
  menuItems: React.createContext({}),
  menuItem: React.createContext({}),
  utilityNavigation: React.createContext({}),
  contextNavigation: React.createContext({}),
  primaryNavigation: React.createContext({}),
  navigation: React.createContext({}),
  session: React.createContext({}),
  heartbeat: React.createContext({}),
  activity: React.createContext({}),
  configuration: React.createContext({}),
  catalogConfiguration: React.createContext({}),
  rootCatalog: React.createContext(null),
  contextCatalog: React.createContext(null)
};

var routingPropsForReactRouterLink = function routingPropsForReactRouterLink(navigationType, _ref) {
  var to = _ref.to;
  return {
    to: to,
    as: NavLink,
    activeClassName: "particles-navigation-link--".concat(navigationType, "-active")
  };
};

var tooltipProps = function tooltipProps(_ref2) {
  var tooltip = _ref2.tooltip;
  return tooltip ? {
    title: tooltip
  } : {};
};

var routingPropsForAnchorTag = function routingPropsForAnchorTag(_ref3) {
  var href = _ref3.href;
  return {
    href: href,
    as: 'a'
  };
};

var externalPropsFor = function externalPropsFor() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      external = _ref4.external;

  return external ? {
    target: '_blank'
  } : {};
};

var extractSubstitutionParameters = function extractSubstitutionParameters(str) {
  var reHrefSub = /{{(.*?)}}/gi;
  var substitutionParameters = [];
  var foundMatches;

  while ((foundMatches = reHrefSub.exec(str)) !== null) {
    substitutionParameters.push(_.get(foundMatches, 1));
  }

  return substitutionParameters;
};

var resolveHref = function resolveHref(href, navigationContext) {
  var hrefList = [].concat(href); // Use first href containing substitution patterns with complete non-empty values in the current context

  var targetHref = _.find(hrefList, function (currentHref) {
    return _.every(_.map(extractSubstitutionParameters(currentHref), function (substitutionParameter) {
      return _.get(navigationContext, substitutionParameter);
    }));
  }) || _.last(hrefList); // Replace substitution values, leaving pattern in-place in case user has specified a single href but no matching parameters exist in context


  var resolvedHref = _.reduce(extractSubstitutionParameters(targetHref), function (result, currentVariableName) {
    return _.replace(result, "{{".concat(currentVariableName, "}}"), _.get(navigationContext, currentVariableName, "{{".concat(currentVariableName, "}}")));
  }, targetHref);

  var incompleteSubstitutions = extractSubstitutionParameters(resolvedHref);

  if (incompleteSubstitutions.length) {
    warn("Warning: CoPilot: Smart links pattern defined for catalog link href does not match any keys in the current navigation context.\n  ".concat(resolvedHref, "\n\n  Consider defining a default/fallback href or ensure the navigation context is updated to include values for\n  - ").concat(_.join(incompleteSubstitutions, '\n  - ')));
  }

  return resolvedHref;
};
var routingPropsFor = function routingPropsFor(navigationType, navigationContext) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      to = _ref5.to,
      href = _ref5.href;

  return to ? routingPropsForReactRouterLink(navigationType, {
    to: to
  }) : routingPropsForAnchorTag({
    href: resolveHref(href, navigationContext)
  });
};
var navigationTypePropsFor = function navigationTypePropsFor(navigationType) {
  return navigationType === 'utility' && {
    utility: true
  } || navigationType === 'primary' && {
    primary: true
  } || {};
};
var preventClick = _.method('preventDefault');
var disabledProps = function disabledProps(navigationType) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      disabled = _ref6.disabled;

  return disabled ? {
    onClick: preventClick,
    className: "disabled-".concat(navigationType, "-link")
  } : {};
};
var baseProps = function baseProps(link) {
  return {
    rel: _.get(link, 'rel', undefined),
    active: _.get(link, 'active', undefined),
    className: _.get(link, 'className', undefined),
    children: _.get(link, 'external') ? React.createElement(React.Fragment, null, _.get(link, 'label', ''), ' ', React.createElement("i", {
      className: "fa fa-external-link"
    })) : _.get(link, 'label', '')
  };
};
var overrideProps = function overrideProps(link) {
  return _objectSpread({}, _.pick(link, ['onClick', 'title', 'alt', 'target', 'title']));
};
var htmlPropsFor$2 = function htmlPropsFor(link, navigationType, getItemProps, navigationContext) {
  return _objectSpread({}, baseProps(link), routingPropsFor(navigationType, navigationContext, link), externalPropsFor(link), navigationTypePropsFor(navigationType), tooltipProps(link), disabledProps(navigationType, link), overrideProps(link), (getItemProps || function () {
    return {};
  })({
    item: link
  }));
};
var Link = function Link(_ref7) {
  var link = _ref7.link,
      catalog = _ref7.catalog,
      navigationType = _ref7.navigationType,
      getItemProps = _ref7.getItemProps;
  var navigationContext = React.useContext(context.navigation);
  var htmlProps = htmlPropsFor$2(link, navigationType, getItemProps, navigationContext);
  return React.createElement(Navigation.Link, htmlProps);
};
Link.displayName = 'Link';

var tooltipProps$1 = function tooltipProps(_ref) {
  var tooltip = _ref.tooltip;
  return tooltip ? {
    title: tooltip
  } : {};
};
var baseProps$1 = function baseProps(link) {
  return {
    className: _.get(link, 'className', undefined),
    children: _.get(link, 'label', '')
  };
};
var overrideProps$1 = function overrideProps(link) {
  return _objectSpread({}, _.pick(link, ['onClick', 'title', 'alt', 'target', 'title']));
};
var htmlPropsFor$3 = function htmlPropsFor(link, navigationType, getItemProps) {
  return _objectSpread({}, baseProps$1(link), tooltipProps$1(link), overrideProps$1(link), (getItemProps || function () {
    return {};
  })({
    item: link
  }));
};
var Text = function Text(_ref3) {
  var link = _ref3.link,
      catalog = _ref3.catalog,
      navigationType = _ref3.navigationType,
      getItemProps = _ref3.getItemProps;
  return _.thru(htmlPropsFor$3(link, navigationType, getItemProps), function (htmlProps) {
    return React.createElement(Navigation.Text, htmlProps);
  });
};
Text.displayName = 'Text';

var labelFrom$1 = function labelFrom(catalog) {
  return function (_ref) {
    var rackspaceAccountNumber = _ref.rackspaceAccountNumber,
        rackspaceAccountName = _ref.rackspaceAccountName;
    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: "context-navigation__rackspace-account-name",
      key: "name"
    }, rackspaceAccountName), ' ', React.createElement("span", {
      className: "context-navigation__rackspace-account-number",
      key: "number"
    }, rackspaceAccountNumber));
  }(contextFrom(catalog));
};

var asText = function asText(link, catalog) {
  return _.merge({}, link, {
    className: "".concat(link.className || '', " janus-particles-defect-rackspace-account-style"),
    type: 'text',
    label: labelFrom$1(catalog)
  });
};

var RackspaceAccount = function RackspaceAccount(_ref2) {
  var link = _ref2.link,
      navigationType = _ref2.navigationType,
      Handler = _ref2.Handler,
      catalog = _ref2.catalog;
  return function (target) {
    return React.createElement(Handler, {
      link: target,
      catalog: catalog,
      navigationType: navigationType
    });
  }(asText(link, catalog));
};
RackspaceAccount.displayName = 'RackspaceAccount';

var labelFrom$2 = function labelFrom(catalog) {
  return function (_ref) {
    var masterPayerAwsAccountNumber = _ref.masterPayerAwsAccountNumber,
        masterPayerAwsAccountName = _ref.masterPayerAwsAccountName;
    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: "context-navigation__master-payer-aws-account-name",
      key: "name"
    }, masterPayerAwsAccountName), ' ', React.createElement("span", {
      className: "context-navigation__master-payer-aws-account-number",
      key: "number"
    }, React.createElement("a", {
      href: "/racker/rackspace-accounts/1/aws-accounts/".concat(masterPayerAwsAccountNumber)
    }, masterPayerAwsAccountNumber)));
  }(contextFrom(catalog));
};

var asText$1 = function asText(link, catalog) {
  return _.merge({}, link, {
    type: 'text',
    label: labelFrom$2(catalog)
  });
};

var MasterPayer = function MasterPayer(_ref2) {
  var link = _ref2.link,
      navigationType = _ref2.navigationType,
      Handler = _ref2.Handler,
      catalog = _ref2.catalog;
  return function (target) {
    return React.createElement(Handler, {
      link: target,
      catalog: catalog,
      navigationType: navigationType
    });
  }(asText$1(link, catalog));
};
MasterPayer.displayName = 'MasterPayer';

var regex = function regex() {
  return /^([^.]+\.[a-zA-Z0-9]).*/;
};

var length = function length() {
  return 8;
};

var unmasked = function unmasked(name) {
  return (regex().exec("".concat(name)) || ['', "".concat(name).substring(0, 4)])[1];
};
var hash = function hash(name) {
  return crypto.createHash('sha1').update("".concat(name)).digest('hex').slice(0, length());
};
var masked = function masked(name) {
  return "racker-".concat(unmasked(name), "-").concat(hash(name));
};

var userIdFrom = function userIdFrom(catalog) {
  return _.get(userFrom(catalog), 'userId');
};

var createTemporaryInput = function createTemporaryInput(value) {
  return _.set(document.createElement('input'), 'value', value);
};

var copyToClipboard = function copyToClipboard(value) {
  return _.tap(createTemporaryInput(value), function (input) {
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  });
};

var handleCopyValueClick = function handleCopyValueClick(value) {
  return function (e) {
    return [_.invoke(e, 'preventDefault'), copyToClipboard(value)];
  };
};

var Icon = function Icon() {
  return React.createElement("i", {
    className: "fa fa-clipboard"
  });
};

Icon.displayName = 'Icon';

var CopyToClipboard = function CopyToClipboard(_ref) {
  var value = _ref.value,
      Component = _ref.as,
      rest = _objectWithoutProperties(_ref, ["value", "as"]);

  return React.createElement(Tooltip, {
    title: "copied!",
    position: "top-end",
    trigger: "click",
    arrow: true
  }, React.createElement(Component, _extends({
    onClick: handleCopyValueClick(value)
  }, rest, {
    className: "janus-copy-to-clipboard"
  }), value, React.createElement(Icon, null)));
};

CopyToClipboard.defaultProps = {
  as: 'a'
};
CopyToClipboard.displayName = 'CopyToClipboard';
var MaskedRackerName = function MaskedRackerName(_ref2) {
  var link = _ref2.link,
      catalog = _ref2.catalog;
  return React.createElement(Navigation.Dropdown.Item, null, React.createElement(Navigation.Dropdown.Item.Label, null, link.label), React.createElement(CopyToClipboard, {
    value: masked(userIdFrom(catalog)),
    as: Navigation.Dropdown.Item.Value
  }));
};
MaskedRackerName.displayName = 'MaskedRackerName';

var userIdFrom$1 = function userIdFrom(catalog) {
  return _.get(userFrom(catalog), 'userId');
};

var RackerSso = function RackerSso(_ref) {
  var link = _ref.link,
      catalog = _ref.catalog;
  return React.createElement(Navigation.Dropdown.Item, null, React.createElement(Navigation.Dropdown.Item.Label, null, link.label), React.createElement(Navigation.Dropdown.Item.Value, null, userIdFrom$1(catalog)));
};
RackerSso.displayName = 'RackerSso';

var regex$1 = function regex() {
  return /^([^.]+\.[a-zA-Z0-9]).*/;
};

var length$1 = function length() {
  return 8;
};

var unmasked$1 = function unmasked(name) {
  return (regex$1().exec("".concat(name)) || ['', "".concat(name).substring(0, 4)])[1];
};

var hash$1 = function hash(name) {
  return crypto.createHash('sha1').update("".concat(name)).digest('hex').slice(0, length$1());
};

var masked$1 = function masked(name) {
  return "racker-".concat(unmasked$1(name), "-").concat(hash$1(name));
};

var email = function email(userId, catalog) {
  return "".concat(userId, "@").concat(_.get(userFrom(catalog), 'rackerGcpDomain'));
};

var userIdFrom$2 = function userIdFrom(catalog) {
  return _.get(userFrom(catalog), 'userId');
};

var createTemporaryInput$1 = function createTemporaryInput(value) {
  return _.set(document.createElement('input'), 'value', value);
};

var copyToClipboard$1 = function copyToClipboard(value) {
  return _.tap(createTemporaryInput$1(value), function (input) {
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  });
};

var handleCopyValueClick$1 = function handleCopyValueClick(value) {
  return function (e) {
    return [_.invoke(e, 'preventDefault'), copyToClipboard$1(value)];
  };
};

var Icon$1 = function Icon() {
  return React.createElement("i", {
    className: "fa fa-clipboard"
  });
};

Icon$1.displayName = 'Icon';

var CopyToClipboard$1 = function CopyToClipboard(_ref) {
  var value = _ref.value,
      Component = _ref.as,
      rest = _objectWithoutProperties(_ref, ["value", "as"]);

  return React.createElement(Tooltip, {
    title: "copied!",
    position: "top-end",
    trigger: "click",
    arrow: true
  }, React.createElement(Component, _extends({
    onClick: handleCopyValueClick$1(value)
  }, rest, {
    className: "janus-copy-to-clipboard"
  }), value, React.createElement(Icon$1, null)));
};

CopyToClipboard$1.defaultProps = {
  as: 'a'
};
CopyToClipboard$1.displayName = 'CopyToClipboard';
var GcpEmail = function GcpEmail(_ref2) {
  var link = _ref2.link,
      catalog = _ref2.catalog;
  return React.createElement(Navigation.Dropdown.Item, null, React.createElement(Navigation.Dropdown.Item.Label, null, link.label), React.createElement(CopyToClipboard$1, {
    value: email(masked$1(userIdFrom$2(catalog)), catalog),
    as: Navigation.Dropdown.Item.Value
  }));
};
GcpEmail.displayName = 'GcpEmail';

var labelFrom$3 = function labelFrom(catalog) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      label = _ref.label;

  return function (_ref2) {
    var billingSubAccountId = _ref2.billingSubAccountId,
        noResell = _ref2.noResell;
    return noResell ? React.createElement("span", {
      className: "context-navigation__no-resell"
    }, "No Resell") : React.createElement(React.Fragment, null, React.createElement("span", {
      className: "context-navigation__billing-sub-account-label",
      key: "name"
    }, label), ' ', React.createElement("span", {
      className: "context-navigation__billing-sub-account-id",
      key: "number"
    }, billingSubAccountId));
  }(contextFrom(catalog));
};

var asText$2 = function asText(link, catalog) {
  return _.merge({}, link, {
    type: 'text',
    label: labelFrom$3(catalog, link)
  });
};

var BillingSubAccount = function BillingSubAccount(_ref3) {
  var link = _ref3.link,
      navigationType = _ref3.navigationType,
      Handler = _ref3.Handler,
      catalog = _ref3.catalog;
  return function (target) {
    return React.createElement(Handler, {
      link: target,
      catalog: catalog,
      navigationType: navigationType
    });
  }(asText$2(link, catalog));
};
BillingSubAccount.displayName = 'BillingSubAccount';

var Logo = function Logo(_ref) {
  var link = _ref.link,
      catalog = _ref.catalog;
  return _.thru(htmlPropsFor$2(link), function (htmlProps) {
    return React.createElement(Navigation.Logo, htmlProps);
  });
};
Logo.displayName = 'Logo';

var Hidden = function Hidden() {
  return null;
};

Hidden.displayName = 'Hidden';

var InvalidLinkTypeHandler = function InvalidLinkTypeHandler() {
  return null;
};

var componentFor = function componentFor() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      type = _ref.type,
      hidden = _ref.hidden;

  var handlers = arguments.length > 1 ? arguments[1] : undefined;
  return hidden ? Hidden : _.get(_objectSpread({}, handlers || {}, {
    'rackspace-account': RackspaceAccount,
    'master-payer': MasterPayer,
    'masked-racker-name': MaskedRackerName,
    'current-user': CurrentUser,
    'racker-sso': RackerSso,
    'gcp-email': GcpEmail,
    'billing-sub-account': BillingSubAccount,
    'link': Link,
    'text': Text,
    'logo': Logo,
    'dropdown': Dropdown,
    'dropdown-group': DropdownGroup
  }), type) || (type ? InvalidLinkTypeHandler : Link);
};

var Handler = function Handler(_ref) {
  var link = _ref.link,
      handlers = _ref.handlers,
      rest = _objectWithoutProperties(_ref, ["link", "handlers"]);

  return function (Component) {
    return React.createElement(Component, _extends({
      link: link
    }, rest, {
      Handler: Handler
    }));
  }(componentFor(link, handlers));
};
Handler.displayName = 'Handler';

var area = function area(_ref) {
  var catalog = _ref.catalog,
      area = _ref.area,
      navigationType = _ref.navigationType,
      right = _ref.right,
      handlers = _ref.handlers;
  return _.thru(linksForArea(catalog, navigationType, area), function (links$$1) {
    return _.map(links$$1, function (link) {
      return React.createElement(Handler, {
        key: link.rel,
        link: link,
        catalog: catalog,
        handlers: handlers,
        navigationType: navigationType
      });
    });
  });
};

var getBoundingClientRect = function getBoundingClientRect(element) {
  return _.invoke(element, 'getBoundingClientRect');
};

var linksFrom = function linksFrom(catalog, path, filterFn) {
  return _.filter(_.compact(_.reject(_.get(catalog, path || 'catalog.utilityNavigation.links'), 'hidden')), filterFn || function () {
    return true;
  });
};

var parse = function parse(catalog, path) {
  var links$$1 = _.map(linksFrom(catalog, path), function () {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread({}, link, {
      href: link.href && _.isArray(link.href) ? _.last(link.href) : link.href
    });
  });

  return {
    links: links$$1
  };
};

var Anchor = function Anchor(_ref) {
  var link = _ref.link,
      className = _ref.className,
      role = _ref.role,
      children = _ref.children;

  var _ref2 = link || {},
      to = _ref2.to,
      href = _ref2.href;

  var Component = to ? NavLink : 'a';
  var target = link.external ? '_blank' : undefined;
  var rel = link.external ? 'noreferrer noopener' : link.rel;
  return React.createElement(Component, {
    href: href,
    to: to,
    className: className,
    role: role,
    target: target,
    rel: rel,
    'data-rel': link.rel
  }, children, !children && (link.label || link.type), !children && link.external && React.createElement(BsBoxArrowUpRight, {
    style: {
      marginLeft: '0.5ch',
      width: '1.125em',
      height: '1.125em'
    }
  }));
};

var Logo$1 = function Logo() {
  var allLinks = _.get(React.useContext(context.utilityNavigation), 'links');

  var logoLink = _.merge(_.head(_.filter(allLinks, function (link) {
    return _.get(link, 'area') === 'logo';
  })), {
    rel: 'logo'
  });

  return React.createElement("div", {
    className: "copilot-utility-nav copilot-utility-nav--logo"
  }, React.createElement(Anchor, {
    link: logoLink,
    key: logoLink.rel
  }, React.createElement("svg", {
    key: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.6 40.8"
  }, React.createElement("path", {
    d: "M22.7 0C31.8-.5 39 5.4 39.5 14.5c.6 10.4-7.7 21-18.5 23.7-3.7.9-7.2.8-10.3-.1-.2-4.1.6-8.4 2.3-11.3 2.9-4.9 7.2-4.4 9.7.9.9 2 1.5 4.4 1.6 7 .9-.5 1.7-1 2.5-1.5-2.7-6.5-3.9-14.2 5.7-27.7-2.8-2.2-7.1-3.3-12.4-2.6.9-1.1 1.8-2 2.6-2.9z"
  }), React.createElement("path", {
    fill: "#B80017",
    d: "M20.5 11c-.8 1.6-.5 3 .7 3s2.7-1.3 3.5-2.9c.8-1.6.5-3-.7-3-1.1 0-2.7 1.3-3.5 2.9zm-.7-4.6C11.6 16.3 8.2 29.2 8.7 40.8 3.9 38.8.4 34.2 0 28.4v-.1c-.6-10.4 7.7-21 18.5-23.7 4.2-1.1 8.2-.8 11.5.6-.7 2-1.8 4.2-3 5.9-2.4 3.6-5.8 5.8-7.7 5-1.8-.8-1.4-4.3 1-7.9.5-.8 1.1-1.5 1.8-2.2-.8.1-1.5.2-2.3.4z"
  }))));
};

var Left = function Left() {
  var allLinks = _.get(React.useContext(context.utilityNavigation), 'links');

  var links$$1 = _.filter(allLinks, function (link) {
    return _.get(link, 'area', 'left') === 'left';
  });

  var active = _.find(links$$1, _.property('active')) || {
    rel: 'active-placeholder',
    label: 'Product'
  };
  var triggerClassName = active.rel !== 'active-placeholder' ? 'copilot-dropdown-trigger--active' : '';
  var trigger = React.createElement(React.Fragment, null, React.createElement("div", {
    className: "copilot-active-display"
  }, active.label), React.createElement(BsChevronDown, {
    className: "copilot-rotate"
  }));
  return React.createElement("div", {
    className: "copilot-utility-nav copilot-utility-nav--left"
  }, renderMenu({
    key: 'product-menu-small',
    links: links$$1,
    triggerClassName: triggerClassName,
    trigger: trigger,
    right: false,
    allLinks: allLinks
  }));
};

var childrenOf = function childrenOf(link, links$$1) {
  return !_.get(link, 'type') || _.get(link, 'type') === 'link' ? [] : _.filter(links$$1, {
    area: _.get(link, 'rel', 'none')
  });
};

var treeOf = function treeOf(targetLinks, allLinks) {
  var layer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return _.flatMap(targetLinks, function (targetLink) {
    var children = childrenOf(targetLink, allLinks);
    var tree = treeOf(children, allLinks, layer + 1);
    return _.concat([_objectSpread({}, targetLink, {
      layer: layer,
      hasChildren: _.some(tree)
    })], tree);
  });
};

var Right = function Right() {
  var allLinks = _.get(React.useContext(context.utilityNavigation), 'links');

  var links$$1 = _.filter(allLinks, function (link) {
    return _.get(link, 'area') === 'right';
  });

  var trigger = React.createElement(BsList, {
    "aria-label": "Admin Menu",
    style: {
      width: '1.75em',
      height: '1.75em',
      marginBottom: '-4px'
    }
  });
  return React.createElement("div", {
    className: "copilot-utility-nav copilot-utility-nav--right"
  }, renderMenu({
    links: links$$1,
    trigger: trigger,
    triggerClassName: 'copilot-small-dropdown',
    right: true,
    allLinks: allLinks
  }), _.map(links$$1, function (link) {
    var trigger = React.createElement(React.Fragment, {
      key: link.rel
    }, React.createElement("span", null, link.label), React.createElement(BsChevronDown, {
      className: "copilot-rotate"
    }));
    return renderMenu({
      key: link.rel,
      links: [link],
      trigger: trigger,
      triggerClassName: 'copilot-large-dropdown',
      right: true,
      allLinks: allLinks
    });
  }), React.createElement(Separator, null));
};

var Separator = function Separator() {
  return React.createElement("div", {
    className: "copilot-utility-nav copilot-utility-nav--separator"
  });
};

var HandleLabel = function HandleLabel(_ref3) {
  var className = _ref3.className;

  var _ref4 = React.useContext(context.menu) || {},
      open = _ref4.open;

  var _ref5 = React.useContext(context.menuItem) || {},
      link = _ref5.link;

  return link.label && link.hasChildren ? React.createElement(React.Fragment, null, React.createElement("span", {
    className: "".concat(className || '', " copilot-menu-item-type--").concat(link.type, " copilot-menu-item copilot-menu-item--").concat(open ? 'open' : 'closed', " copilot-menu-item--layer-").concat(link.layer, " copilot-menu-item--").concat(link.hasChildren ? 'with-children' : 'with-no-children')
  }, link.label)) : null;
};

var HandleLink = function HandleLink(_ref6) {
  var className = _ref6.className;

  var _ref7 = React.useContext(context.menu) || {},
      open = _ref7.open;

  var _ref8 = React.useContext(context.menuItem) || {},
      link = _ref8.link;

  return React.createElement(Menu.Item, {
    key: link.rel
  }, function (_ref9) {
    var active = _ref9.active;
    return React.createElement(Anchor, {
      role: "menuitem",
      link: link,
      className: "".concat(className || '', " copilot-menu-item copilot-menu-item--").concat(open ? 'open' : 'closed', " copilot-menu-item--").concat(active ? 'active' : 'inactive', " copilot-menu-item--layer-").concat(link.layer)
    });
  });
};

var HandleUnknown = function HandleUnknown() {
  var _ref10 = React.useContext(context.menuItem) || {},
      link = _ref10.link;

  return React.createElement("div", {
    className: "copilot-unknown"
  }, "Unknown: ", link.type);
};

var HandleRackerMaskedSso = function HandleRackerMaskedSso() {
  var _ref11 = React.useContext(context.rootCatalog) || {},
      catalog = _ref11.catalog;

  var _ref12 = React.useContext(context.menuItem) || {},
      link = _ref12.link;

  var _ref13 = userFrom({
    catalog: catalog
  }) || {},
      userId = _ref13.userId;

  var maskedUserId = masked(userId);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "copilot-menu-item--special copilot-menu-item copilot-menu-item--layer-1"
  }, React.createElement("div", {
    id: "copilot-racker-masked-sso",
    className: "copilot-menu-text__name"
  }, link.label), React.createElement("div", {
    "aria-labelledby": "copilot-racker-masked-sso",
    className: "copilot-menu-text__id"
  }, maskedUserId)));
};

var HandleRackerSso = function HandleRackerSso() {
  var _ref14 = React.useContext(context.rootCatalog) || {},
      catalog = _ref14.catalog;

  var _ref15 = React.useContext(context.menuItem) || {},
      link = _ref15.link;

  var _ref16 = userFrom({
    catalog: catalog
  }) || {},
      userId = _ref16.userId;

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "copilot-menu-item--special copilot-menu-item copilot-menu-item--layer-1"
  }, React.createElement("div", {
    id: "copilot-racker-sso",
    className: "copilot-menu-text__name"
  }, link.label), React.createElement("div", {
    "aria-labelledby": "copilot-racker-sso",
    className: "copilot-menu-text__id"
  }, userId)));
};

var HandleMasterPayer = function HandleMasterPayer() {
  var _ref17 = React.useContext(context.contextCatalog) || {},
      catalog = _ref17.catalog;

  var _ref18 = contextFrom({
    catalog: catalog
  }) || {},
      masterPayerAwsAccountName = _ref18.masterPayerAwsAccountName,
      masterPayerAwsAccountNumber = _ref18.masterPayerAwsAccountNumber;

  return React.createElement("div", {
    className: "copilot-context-text copilot-large-dropdown"
  }, React.createElement("span", {
    className: "copilot-context-text__name"
  }, masterPayerAwsAccountName), React.createElement("span", {
    className: "copilot-context-text__id"
  }, masterPayerAwsAccountNumber));
};

var HandleRackspaceAccount = function HandleRackspaceAccount() {
  var _ref19 = React.useContext(context.contextCatalog) || {},
      catalog = _ref19.catalog;

  var _ref20 = contextFrom({
    catalog: catalog
  }) || {},
      rackspaceAccountNumber = _ref20.rackspaceAccountNumber,
      rackspaceAccountName = _ref20.rackspaceAccountName;

  return React.createElement("div", {
    className: "copilot-context-text"
  }, React.createElement("span", {
    className: "copilot-context-text__name"
  }, rackspaceAccountName), React.createElement("span", {
    className: "copilot-context-text__id"
  }, rackspaceAccountNumber));
};

var resolveComponent = function resolveComponent() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      link = _ref21.link;

  var type = _.get(link, 'type') || 'link';
  return _.get({
    link: HandleLink,
    'racker-sso': HandleRackerSso,
    'masked-racker-name': HandleRackerMaskedSso,
    'rackspace-account': HandleRackspaceAccount,
    'master-payer': HandleMasterPayer,
    'dropdown-group': HandleLabel,
    'dropdown': HandleLabel
  }, _.kebabCase(type)) || HandleUnknown;
};

var renderMenuItem = function renderMenuItem() {
  return function (link) {
    var Component = resolveComponent({
      link: link
    });
    return React.createElement(context.menuItem.Provider, {
      value: {
        link: link
      },
      key: link.rel
    }, React.createElement(Component, null));
  };
};

var renderMenu = function renderMenu() {
  var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      key = _ref22.key,
      trigger = _ref22.trigger,
      triggerClassName = _ref22.triggerClassName,
      links$$1 = _ref22.links,
      allLinks = _ref22.allLinks,
      right = _ref22.right;

  return _.some(links$$1) ? React.createElement(Menu, {
    key: key,
    as: "div",
    className: "copilot-menu-wrapper"
  }, function (_ref23) {
    var open = _ref23.open;
    return React.createElement(context.menu.Provider, {
      value: {
        open: open,
        links: links$$1,
        allLinks: allLinks
      }
    }, React.createElement(React.Fragment, null, React.createElement(Menu.Button, {
      className: "".concat(triggerClassName || '', " copilot-dropdown-trigger copilot-dropdown-trigger--").concat(open ? 'open' : 'closed')
    }, trigger), React.createElement(Transition, {
      className: "copilot-menu copilot-menu--".concat(right ? 'right' : 'left'),
      show: !!open,
      enterFrom: "copilot-menu--closed",
      enterTo: "copilot-menu--open",
      leaveFrom: "copilot-menu--open",
      leaveTo: "copilot-menu--closed"
    }, React.createElement(Menu.Items, {
      static: true,
      className: "copilot-menu-items"
    }, React.createElement(React.Fragment, null, _.map(treeOf(links$$1, allLinks), renderMenuItem(allLinks)))))));
  }) : React.createElement("span", {
    className: "".concat(triggerClassName || '', " copilot-dropdown-trigger copilot-dropdown-trigger--invisible")
  }, trigger);
};

var User = function User() {
  var allLinks = _.get(React.useContext(context.utilityNavigation), 'links');

  var links$$1 = _.filter(allLinks, function (link) {
    return _.get(link, 'area') === 'user';
  });

  var trigger = React.createElement(BsPersonCircle, {
    style: {
      width: '1.75em',
      height: '1.75em',
      marginBottom: '-4px'
    }
  });
  return React.createElement("div", {
    className: "copilot-utility-nav copilot-utility-nav--user"
  }, renderMenu({
    links: links$$1,
    trigger: trigger,
    right: true,
    allLinks: allLinks
  }));
};

var Context = function Context() {
  var allLinks = _.get(React.useContext(context.contextNavigation), 'links');

  var links$$1 = _.filter(allLinks, function () {
    return true;
  });

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "copilot-context-nav copilot-context-nav--all"
  }, _.map(links$$1, renderMenuItem(allLinks))));
};

var useWindowSize = function useWindowSize() {
  var _React$useState = React.useState({
    width: global.innerWidth,
    height: global.innerHeight
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      windowSize = _React$useState2[0],
      setWindowSize = _React$useState2[1];

  React.useEffect(function () {
    var timeoutId = null;

    var handleResize = function handleResize() {
      global.clearTimeout(timeoutId);
      timeoutId = global.setTimeout(function () {
        setWindowSize({
          width: global.innerWidth,
          height: global.innerHeight
        });
      }, 100);
    };

    global.addEventListener('resize', handleResize);
    global.addEventListener('orientationchange', handleResize);

    _.invoke(global.screen, 'addEventListener', 'onchange', handleResize);

    handleResize();
    return function () {
      global.clearTimeout(timeoutId);
      global.removeEventListener('resize', handleResize);
      global.removeEventListener('orientationchange', handleResize);

      _.invoke(global.screen, 'removeEventListener', 'onchange', handleResize);
    };
  }, [setWindowSize]);
  return [windowSize, setWindowSize];
};

var morePlaceholder = {
  label: '',
  rel: 'active-placeholder'
};

var Full = function Full() {
  var _useWindowSize = useWindowSize(),
      _useWindowSize2 = _slicedToArray(_useWindowSize, 2),
      windowSize = _useWindowSize2[0],
      setWindowSize = _useWindowSize2[1];

  var visibleRef = React.useRef(null);

  var allLinks = _.get(React.useContext(context.primaryNavigation), 'links');

  var _React$useState3 = React.useState(_.orderBy(_.filter(allLinks, function () {
    return true;
  }), function (link) {
    return link.active ? 0 : 0;
  })),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      links$$1 = _React$useState4[0];

  var _React$useState5 = React.useState(links$$1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      menuLinks = _React$useState6[0],
      setMenuLinks = _React$useState6[1];

  var _React$useState7 = React.useState(links$$1),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      priorityLinks = _React$useState8[0],
      setPriorityLinks = _React$useState8[1];

  var _React$useState9 = React.useState(_.find(menuLinks, {
    active: true
  }) || morePlaceholder),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      activeMenuLink = _React$useState10[0],
      setActiveMenuLink = _React$useState10[1];

  var _React$useState11 = React.useState(activeMenuLink.rel !== 'active-placeholder' ? 'copilot-dropdown-trigger--active' : ''),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      triggerClassName = _React$useState12[0],
      setTriggerClassName = _React$useState12[1];

  var triggerSmall = React.createElement(React.Fragment, null, React.createElement("div", {
    className: "copilot-more"
  }, activeMenuLink.label, ' '), React.createElement(BsThreeDots, {
    "aria-label": "See More",
    style: {
      width: '1.75em',
      height: '1.75em',
      marginBottom: '-2px'
    }
  }));
  React.useEffect(function () {
    var activePriority = _.find(priorityLinks, {
      active: true
    });

    var activeMenu = _.find(menuLinks, {
      active: true
    });

    var timeoutId = null;

    if (activeMenu && !activePriority) {
      setMenuLinks(function (current) {
        return _.concat([_.last(priorityLinks)], _.without(current, activeMenu));
      });
      setPriorityLinks(function (current) {
        return _.concat(_.without(current, _.last(priorityLinks)), [activeMenu]);
      });
      setTriggerClassName('');
      setActiveMenuLink(morePlaceholder);
      timeoutId = global.setTimeout(function () {
        return setWindowSize(function (current) {
          return _objectSpread({}, current);
        });
      }, 1);
    }

    return function () {
      return global.clearTimeout(timeoutId);
    };
  }, [priorityLinks, menuLinks, setMenuLinks, setPriorityLinks, setTriggerClassName, setActiveMenuLink, setWindowSize]);
  React.useEffect(function () {
    setPriorityLinks(links$$1);
    setMenuLinks([]);
    var timeoutId = global.setTimeout(function () {
      var navRect = getBoundingClientRect(visibleRef.current);
      var availableSpace = +navRect.width || 0;

      var _$reduce = _.reduce(links$$1, function (_ref24, link) {
        var used = _ref24.used,
            priority = _ref24.priority,
            extra = _ref24.extra;

        var element = _.invoke(visibleRef, 'current.querySelector', "[data-rel=\"".concat(link.rel, "\"]"));

        var elementRect = getBoundingClientRect(element) || {};
        var newUsed = used + (+elementRect.width || 1);
        var newPriority = newUsed <= availableSpace ? [].concat(_toConsumableArray(priority), [link]) : priority;
        var newExtra = newUsed > availableSpace ? [].concat(_toConsumableArray(extra), [link]) : extra;
        return {
          used: newUsed,
          priority: newPriority,
          extra: newExtra
        };
      }, {
        used: 0,
        priority: [],
        extra: []
      }),
          priority = _$reduce.priority,
          extra = _$reduce.extra;

      setPriorityLinks(priority);
      setMenuLinks(extra);
      setActiveMenuLink(_.find(extra, {
        active: true
      }) || morePlaceholder);
    }, 1);
    return function () {
      return global.clearTimeout(timeoutId);
    };
  }, [visibleRef, windowSize, setMenuLinks, setPriorityLinks, setActiveMenuLink, links$$1]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "copilot-primary-nav copilot-primary-nav--all",
    ref: visibleRef
  }, _.map(priorityLinks, function (link) {
    return React.createElement(Anchor, {
      className: "copilot-menu-item copilot-primary-menu-item--priority",
      key: link.rel,
      link: link
    });
  })), React.createElement("div", {
    className: "copilot-primary-nav copilot-primary-nav--trigger"
  }, renderMenu({
    key: 'primary-menu-small',
    links: menuLinks,
    triggerClassName: triggerClassName,
    trigger: triggerSmall,
    right: true,
    allLinks: allLinks
  })));
};

var ContextNavigation = function ContextNavigation(props) {
  var contextValue = _.merge(_.pick(props, ['catalog']), parse(props.catalog, 'catalog.contextNavigation.links'));

  return React.createElement(context.contextNavigation.Provider, {
    value: _objectSpread({}, contextValue)
  }, React.createElement(React.Fragment, null, React.createElement("nav", {
    className: "copilot-nav-root-v2 copilot-nav-root-v2--context"
  }, React.createElement(Context, null))));
};
var PrimaryNavigation = function PrimaryNavigation(props) {
  var contextValue = _.merge(_.pick(props, ['catalog']), parse(props.catalog, 'catalog.primaryNavigation.links'));

  return React.createElement(context.primaryNavigation.Provider, {
    value: _objectSpread({}, contextValue)
  }, React.createElement(React.Fragment, null, React.createElement("nav", {
    className: "copilot-nav-root-v2 copilot-nav-root-v2--primary"
  }, React.createElement(Full, null))));
};
var UtilityNavigation = function UtilityNavigation(props) {
  var contextValue = _.merge(_.pick(props, ['catalog']), parse(props.catalog, 'catalog.utilityNavigation.links'));

  return React.createElement(context.utilityNavigation.Provider, {
    value: _objectSpread({}, contextValue)
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "copilot-gradient-bar"
  }), React.createElement("nav", {
    className: "copilot-nav-root-v2 copilot-nav-root-v2--utility"
  }, React.createElement(Logo$1, null), React.createElement(Left, null), React.createElement(Right, null), React.createElement(User, null))));
};
var Responsive = {
  UtilityNavigation: UtilityNavigation,
  PrimaryNavigation: PrimaryNavigation,
  ContextNavigation: ContextNavigation
};

var copilotLocation = {
  replace: function replace() {
    var _global$location;

    return (_global$location = global.location).replace.apply(_global$location, arguments);
  },
  search: function search() {
    return global.location.search;
  },
  origin: function origin() {
    return global.location.origin;
  },
  pathname: function pathname() {
    return global.location.pathname;
  },
  href: function href() {
    return global.location.href;
  }
};

var resolveDefaultFeatureFlags = function resolveDefaultFeatureFlags() {
  return {
    responsive: /responsive=true/i.test(copilotLocation.search()),
    pilotTest: /pilotTest/i.test(copilotLocation.search())
  };
};

var noChildren = function noChildren() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _.map(args, function (arg) {
    return _.omitBy(arg, function (value, key) {
      return key === 'children';
    });
  });
};

var memoizedMergeResult = _.memoize(function () {
  return _.merge.apply(_, _toConsumableArray(noChildren.apply(void 0, arguments)));
}, function () {
  return safeStringify(_.merge.apply(_, _toConsumableArray(noChildren.apply(void 0, arguments))));
});
var useConfiguration = function useConfiguration() {
  var catalogConfig = React.useContext(context.catalogConfiguration) || {};

  var _ref = React.useContext(context.configuration) || {},
      config = _ref.config;

  for (var _len2 = arguments.length, overrides = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    overrides[_key2] = arguments[_key2];
  }

  return memoizedMergeResult.apply(void 0, [{}, catalogConfig, config].concat(overrides));
};
var useConfigurationValue = function useConfigurationValue(key, componentProps, defaultValue) {
  var config = useConfiguration();
  return _.get(componentProps, key, _.get(config, key, defaultValue));
};
var defaultBaseUrl = function defaultBaseUrl() {
  return copilotLocation.origin() || 'https://manage.rackspace.com';
};

var configWithDefaults = function configWithDefaults() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return memoizedMergeResult.apply(void 0, [{
    featureFlags: resolveDefaultFeatureFlags(),
    baseUrl: defaultBaseUrl()
  }].concat(args));
};

var ConfigurationProvider = function ConfigurationProvider(_ref2) {
  var children = _ref2.children,
      config = _objectWithoutProperties(_ref2, ["children"]);

  var aggregatedConfigurationWithPotentialParentProviders = useConfiguration(config);
  return React.createElement(context.configuration.Provider, {
    value: {
      config: configWithDefaults(aggregatedConfigurationWithPotentialParentProviders)
    }
  }, React.createElement(React.Fragment, null, children));
};
ConfigurationProvider.displayName = 'ConfigurationProvider';

var PrimaryNavigation$1 = function PrimaryNavigation$$1(props) {
  var responsive = useConfigurationValue('featureFlags.responsive', props);
  return responsive ? React.createElement(Responsive.PrimaryNavigation, props) : React.createElement(Navigation, null, React.createElement(Navigation.Primary, null, React.createElement(Navigation.Menu, {
    primary: true
  }, area(_objectSpread({}, props, {
    navigationType: 'primary',
    area: 'left'
  })))));
};
PrimaryNavigation$1.displayName = 'PrimaryNavigation';

var copilotDocument = {
  createRange: function createRange() {
    var _global$document;

    return (_global$document = global.document).createRange.apply(_global$document, arguments);
  },
  querySelector: function querySelector() {
    var _global$document2;

    return (_global$document2 = global.document).querySelector.apply(_global$document2, arguments);
  },
  body: function body() {
    return global.document.body;
  }
};

var sentryClientForClassComponent = function sentryClientForClassComponent(_ref) {
  var context$$1 = _ref.context,
      props = _ref.props;
  return _.get(context$$1, 'config.sentry', _.get(props, 'sentry')) || defaultSentry;
};
var sentryClientForConfiguration = function sentryClientForConfiguration(configuration, props) {
  return _.get(configuration, 'sentry', _.get(props, 'sentry')) || defaultSentry;
};
var reportFromErrorBoundary = function reportFromErrorBoundary(_ref2) {
  var context$$1 = _ref2.context,
      props = _ref2.props;
  return function (_ref3) {
    var error = _ref3.error,
        reactInfo = _ref3.reactInfo;
    var sentry = sentryClientForClassComponent({
      context: context$$1,
      props: props
    });
    sentry.withScope(function (scope) {
      scope.setExtras(reactInfo);
      sentry.captureException(error);
    });
  };
};

var onError = function onError(_ref4) {
  var context$$1 = _ref4.context,
      props = _ref4.props;
  return _.get(context$$1, 'config.onError', props.onError) || function () {
    return null;
  };
}; // generally speaking we shouldn't be using classes anymore anywhere... however this is an exception
// unfortunately we still have to use a class here because (from react docs):
// "componentDidCatch and getDerivedStateFromError: There are no Hook equivalents for these methods yet"
// (reference: https://reactjs.org/docs/hooks-faq.html#how-do-lifecycle-methods-correspond-to-hooks)


var ErrorBoundary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ErrorBoundary)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      error: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidCatch", function (error, reactInfo) {
      return [reportFromErrorBoundary(_assertThisInitialized(_assertThisInitialized(_this)))({
        error: error,
        reactInfo: reactInfo
      }), onError(_assertThisInitialized(_assertThisInitialized(_this)))({
        error: error,
        reactInfo: reactInfo
      })];
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      var renderOnError = _.get(_this.context, 'config.renderOnError', _this.props.renderOnError);

      return _this.state.error && _.isFunction(renderOnError) ? renderOnError(_this.state, _this.props.children) : _this.props.children || null;
    });

    return _this;
  }

  return ErrorBoundary;
}(React.Component);
ErrorBoundary.contextType = context.configuration;

ErrorBoundary.getDerivedStateFromError = function (error) {
  return {
    error: error
  };
};

ErrorBoundary.displayName = 'ErrorBoundary';

var dev = {
  xplat: 'https://xplat-proxy.dev.security.rackspace.com',
  accessRequests: 'https://passport.api.dev.manage.rackspace.com/v0/accessRequests',
  bastionImages: 'https://passport.api.dev.manage.rackspace.com/v0/bastionImages',
  bastionKnownSourceIps: 'https://passport.api.dev.manage.rackspace.com/v0/knownSourceIps',
  serviceLevels: 'https://accounts.api.dev.manage.rackspace.com/v0/serviceLevels',
  watchmanWebhooks: 'https://watchman.api.dev.manage.rackspace.com/v0/webhooks',
  accounts: 'https://accounts.api.dev.manage.rackspace.com',
  audit: 'https://logbook.api.dev.manage.rackspace.com/v0',
  auth: 'https://proxy.api.manage.rackspace.com/identity',
  heimdall: 'https://heimdall.api.dev.manage.rackspace.com',
  waypoint: 'https://waypoint.api.dev.manage.rackspace.com',
  encoreTicketing: 'https://proxy.api.manage.rackspace.com/encore-api',
  customerAccounts: 'https://proxy.api.manage.rackspace.com/customer/v1',
  customerAccountsAdmin: 'https://proxy.api.manage.rackspace.com/customer-admin/v3',
  customerAdmin: 'https://proxy.api.manage.rackspace.com/customer-admin',
  billing: 'https://billing.api.dev.manage.rackspace.com',
  cloudhealth: 'https://cloudhealth.api.dev.manage.rackspace.com',
  rackspaceBilling: 'https://proxy.api.manage.rackspace.com/billingv2',
  resource: 'https://resource.api.dev.manage.rackspace.com',
  passport: 'https://passport.api.dev.manage.rackspace.com',
  'proxy-iad': 'https://proxy-iad.api.manage.rackspace.com',
  'proxy-dfw': 'https://proxy-dfw.api.manage.rackspace.com',
  'proxy-weighted': 'https://proxy.api.manage.rackspace.com',
  gcp: 'https://gcp.api.dev.manage.rackspace.com',
  azure: 'https://azure.api.dev.manage.rackspace.com',
  'azure-passport': 'https://azure-passport.api.dev.manage.rackspace.com',
  mercury: 'https://mercury.api.dev.manage.rackspace.com/v0',
  vmc: 'https://api.vmc.dev.manage.rackspace.com',
  goss: 'https://api.goss.dev.vdo.manage.rackspace.com',
  rpcv: 'https://api.dev.rpc-v.rackspace-cloud.com',
  snooze: 'https://api.snooze.mpcse.internal.dev.manage.rackspace.com',
  stap: 'https://api.stap.mpcse.internal.dev.manage.rackspace.com',
  vspot: 'https://api.vspot.dev.vdo.manage.rackspace.com',
  patching: 'https://patching.api.dev.manage.rackspace.com',
  pilot: 'https://pilot.manage.rackspace.com',
  'pilot-test': 'https://test.pilot.manage.rackspace.com'
};
var prod = {
  xplat: 'https://xplat-proxy.security.rackspace.com',
  accessRequests: 'https://passport.api.manage.rackspace.com/v0/accessRequests',
  bastionImages: 'https://passport.api.manage.rackspace.com/v0/bastionImages',
  bastionKnownSourceIps: 'https://passport.api.manage.rackspace.com/v0/knownSourceIps',
  serviceLevels: 'https://accounts.api.manage.rackspace.com/v0/serviceLevels',
  watchmanWebhooks: 'https://watchman.api.manage.rackspace.com/v0/webhooks',
  accounts: 'https://accounts.api.manage.rackspace.com',
  audit: 'https://logbook.api.manage.rackspace.com/v0',
  auth: 'https://proxy.api.manage.rackspace.com/identity',
  heimdall: 'https://heimdall.api.manage.rackspace.com',
  waypoint: 'https://waypoint.api.manage.rackspace.com',
  encoreTicketing: 'https://proxy.api.manage.rackspace.com/encore-api',
  customerAccounts: 'https://proxy.api.manage.rackspace.com/customer/v1',
  customerAccountsAdmin: 'https://proxy.api.manage.rackspace.com/customer-admin/v3',
  customerAdmin: 'https://proxy.api.manage.rackspace.com/customer-admin',
  billing: 'https://billing.api.manage.rackspace.com',
  cloudhealth: 'https://cloudhealth.api.manage.rackspace.com',
  rackspaceBilling: 'https://proxy.api.manage.rackspace.com/billingv2',
  resource: 'https://resource.api.manage.rackspace.com',
  passport: 'https://passport.api.manage.rackspace.com',
  'proxy-iad': 'https://proxy-iad.api.manage.rackspace.com',
  'proxy-dfw': 'https://proxy-dfw.api.manage.rackspace.com',
  'proxy-weighted': 'https://proxy.api.manage.rackspace.com',
  gcp: 'https://gcp.api.manage.rackspace.com',
  azure: 'https://azure.api.manage.rackspace.com',
  'azure-passport': 'https://azure-passport.api.manage.rackspace.com',
  mercury: 'https://mercury.api.manage.rackspace.com/v0',
  vmc: 'https://api.vmc.manage.rackspace.com',
  goss: 'https://api.goss.vdo.manage.rackspace.com',
  rpcv: 'https://api.rpc-v.rackspace-cloud.com',
  snooze: 'https://api.snooze.mpcse.internal.manage.rackspace.com',
  stap: 'https://api.stap.mpcse.internal.manage.rackspace.com',
  vspot: 'https://api.vspot.vdo.manage.rackspace.com',
  patching: 'https://patching.api.manage.rackspace.com',
  pilot: 'https://pilot.manage.rackspace.com',
  'pilot-test': 'https://test.pilot.manage.rackspace.com'
};
var env = function env(root) {
  return _.includes(root || copilotLocation.origin(), 'dev.manage.rackspace.com') ? 'dev' : 'prod';
};
var urls = function urls(root) {
  return _.get({
    dev: dev,
    prod: prod
  }, env(root));
};
var url = function url(slug, root) {
  return _.get(urls(root), slug);
};

var toFullUrl = function toFullUrl(baseUrl) {
  return _.startsWith(baseUrl, 'http') ? baseUrl : "".concat(copilotLocation.origin(), "/").concat(_.replace(baseUrl, /^\//, ''));
};

var catalogUrls = function catalogUrls(url) {
  return _.reduce([['/racker/copilot/catalog.json', '/login/r/catalog'], ['/aws/copilot/catalog.json', '/login/c/catalog']], function (url, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        janusUi = _ref2[0],
        janusLogin = _ref2[1];

    return _.replace(url, janusUi, janusLogin);
  }, url);
};

var fromJanusUiToJanusLogin = function fromJanusUiToJanusLogin(janusUiUrl) {
  var janusUiFullUrl = toFullUrl(janusUiUrl);

  if (!_.includes(janusUiFullUrl, '/racker/api') && !_.includes(janusUiFullUrl, '/aws/api')) {
    return catalogUrls(_.replace(janusUiFullUrl, '//local.dev', '//dev'));
  }

  var _$split = _.split(janusUiFullUrl, /\/(racker|aws)\/api\//),
      _$split2 = _slicedToArray(_$split, 3),
      janusUiRoot = _$split2[0],
      janusUiAudience = _$split2[1],
      janusUiPathWithSlug = _$split2[2];

  var _$split3 = _.split(janusUiPathWithSlug, '/'),
      _$split4 = _toArray(_$split3),
      slug = _$split4[0],
      apiPathParts = _$split4.slice(1);

  var apiBackendUrl = url(slug, janusUiRoot);
  var apiFullUrl = _.some(apiPathParts) ? "".concat(apiBackendUrl, "/").concat(apiPathParts.join('/')) : apiBackendUrl;
  var audience = janusUiAudience === 'racker' ? 'r' : 'c';
  var janusLoginUrl = "".concat(_.replace(janusUiRoot, 'local.dev', 'dev'), "/ui-proxy/").concat(audience, "/").concat(encodeURIComponent(apiFullUrl));
  return janusLoginUrl;
};

var hangingPromiseToWaitForRedirect = function hangingPromiseToWaitForRedirect() {
  return new Promise(_.noop);
};

var audience = function audience(config) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : copilotLocation.pathname();
  return config.racker || /\/racker(\/|$)/i.test(pathname) ? 'r' : 'c';
};

var loginUrl = function loginUrl(config, baseUrl) {
  return "".concat(baseUrl || copilotLocation.origin(), "/login/").concat(audience(config || {}));
};

var createBaseLoginUrlWithAudience = function createBaseLoginUrlWithAudience() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var baseUrl = _.get(config, 'baseUrl');

  return loginUrl(config, baseUrl);
};
var createLoginUrl = function createLoginUrl() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var baseUrl = _.get(config, 'baseUrl');

  var relayState = /local\./i.test(copilotLocation.origin()) ? copilotLocation.href() : _.replace(copilotLocation.href(), copilotLocation.origin(), '');
  var query = ["cloud=".concat(config.cloud || 'aws'), "RelayState=".concat(encodeURIComponent(relayState)), "invalidateCache=".concat(+Date.now())].join('&');
  return "".concat(loginUrl(config, baseUrl), "?").concat(query);
};
var redirectToLogin = function redirectToLogin(config) {
  copilotLocation.replace(createLoginUrl(config));
};

var handleLoginRedirects = function handleLoginRedirects(shouldRedirect, errorName, config, error) {
  if (shouldRedirect && error.name === errorName) {
    redirectToLogin(config);
    return hangingPromiseToWaitForRedirect();
  }

  return null;
};

var handleUnauthorized = function handleUnauthorized(config, error) {
  var loginOnUnauthorized = _.get(config, 'loginOnUnauthorized');

  return handleLoginRedirects(loginOnUnauthorized, 'Unauthorized', config, error);
};

var handleForbidden = function handleForbidden(config, error) {
  var loginOnForbidden = _.get(config, 'loginOnForbidden');

  return handleLoginRedirects(loginOnForbidden, 'Forbidden', config, error);
};

var verrorFrom = function verrorFrom(_ref) {
  var url$$1 = _ref.url,
      requestId = _ref.requestId,
      config = _ref.config,
      fetchOptions = _ref.fetchOptions,
      res = _ref.res,
      error = _ref.error;

  var errorMessage = _.get(config, 'errorMessage', 'Something Went Wrong');

  var errorName = _.get(config, 'errorName', 'InvalidResponse');

  return new VError({
    name: errorName,
    info: {
      url: url$$1,
      requestId: requestId,
      method: fetchOptions.method,
      status: _.get(res, 'status', '-')
    },
    cause: _.isError(error) ? error : new Error("".concat(error))
  }, errorMessage);
};

var genericError = function genericError(_ref2) {
  var config = _ref2.config,
      url$$1 = _ref2.url,
      requestId = _ref2.requestId,
      fetchOptions = _ref2.fetchOptions,
      error = _ref2.error;

  var errorName = _.get(config, 'errorName', 'NetworkFailure');

  var verror = verrorFrom({
    url: url$$1,
    requestId: requestId,
    config: _objectSpread({}, config, {
      errorName: errorName
    }),
    fetchOptions: fetchOptions,
    error: error
  });
  var sentry = sentryClientForConfiguration(config);
  sentry.withScope(function (scope) {
    scope.setExtras(VError.info(verror));
    sentry.captureException(verror);
  });
  return Promise.reject(verror);
};

var invalidStatus = function invalidStatus(target) {
  return function (_ref3) {
    var status = _ref3.status;
    return [].concat(target).indexOf(status) >= 0 && target;
  };
};

var reportIfNeeded = function reportIfNeeded(_ref4, res) {
  var url$$1 = _ref4.url,
      requestId = _ref4.requestId,
      config = _ref4.config,
      fetchOptions = _ref4.fetchOptions;

  var reportOn = _.get(config, 'reportOn', function () {
    return false;
  });

  var reportOnFn = _.isFunction(reportOn) ? reportOn : invalidStatus(reportOn);
  var error = reportOnFn(res);

  if (error) {
    var verror = verrorFrom({
      url: url$$1,
      requestId: requestId,
      config: config,
      fetchOptions: fetchOptions,
      res: res,
      error: error
    });
    var sentry = sentryClientForConfiguration(config);
    sentry.withScope(function (scope) {
      scope.setExtras(VError.info(verror));
      sentry.captureException(verror);
    });
  }

  return res;
};

var rejectIfNeeded = function rejectIfNeeded(_ref5, res) {
  var url$$1 = _ref5.url,
      requestId = _ref5.requestId,
      config = _ref5.config,
      fetchOptions = _ref5.fetchOptions;

  var rejectOn = _.get(config, 'rejectOn', function () {
    return false;
  });

  var rejectOnFn = _.isFunction(rejectOn) ? rejectOn : invalidStatus(rejectOn);
  var error = rejectOnFn(res);

  if (error) {
    var verror = verrorFrom({
      url: url$$1,
      requestId: requestId,
      config: config,
      fetchOptions: fetchOptions,
      res: res,
      error: error
    });
    return Promise.reject(verror);
  }

  return res;
};

var handleError = function handleError(_ref6, fetchOptions, error) {
  var url$$1 = _ref6.url,
      requestId = _ref6.requestId,
      config = _ref6.config;
  return handleUnauthorized(config, error) || handleForbidden(config, error) || genericError({
    url: url$$1,
    requestId: requestId,
    config: config,
    fetchOptions: fetchOptions,
    error: error
  });
};

var handleJsonResponse = function handleJsonResponse(_ref7, res) {
  var requestId = _ref7.requestId;
  return res.text().then(function (rawResponseBody) {
    try {
      return Promise.resolve(JSON.parse(rawResponseBody));
    } catch (errorParsingJson) {
      return Promise.reject(new VError({
        cause: errorParsingJson,
        name: 'InvalidJSON',
        info: _objectSpread({
          requestId: requestId,
          rawResponseBody: rawResponseBody
        }, _.pick(res, ['status', 'url', 'ok', 'redirected']))
      }, 'Something went wrong'));
    }
  });
};

var enhanceResponse = function enhanceResponse(_ref8, res) {
  var requestId = _ref8.requestId;
  res.requestId = requestId;
  res.parseJson = _.partial(handleJsonResponse, {
    requestId: requestId
  }, res);
  return res;
};

var checkForUnauthorized = function checkForUnauthorized(_ref9, res) {
  var requestId = _ref9.requestId,
      config = _ref9.config;

  if (res.status !== 401 || _.get(config, 'ignoreUnauthorized') || !_.get(config, 'loginOnUnauthorized')) {
    return Promise.resolve(res);
  }

  return Promise.reject(new VError({
    name: 'Unauthorized',
    info: _objectSpread({
      requestId: requestId
    }, _.pick(res, ['status', 'url', 'ok', 'redirected']))
  }));
};

var checkForForbidden = function checkForForbidden(_ref10, res) {
  var requestId = _ref10.requestId,
      config = _ref10.config;

  if (res.status !== 403 || _.get(config, 'ignoreForbidden') || !_.get(config, 'loginOnForbidden')) {
    return Promise.resolve(res);
  }

  return Promise.reject(new VError({
    name: 'Forbidden',
    info: _objectSpread({
      requestId: requestId
    }, _.pick(res, ['status', 'url', 'ok', 'redirected']))
  }));
};

var withSafeBody = function withSafeBody() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return options.body ? _.merge(options, {
    body: _.isString(options.body) ? options.body : safeStringify(options.body)
  }) : options;
};

var csrfCookieHeaders = function csrfCookieHeaders() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref11$janusLoginServ = _ref11.janusLoginServerCsrfCookieName,
      janusLoginServerCsrfCookieName = _ref11$janusLoginServ === void 0 ? '__janus_login_csurf_prod__' : _ref11$janusLoginServ,
      _ref11$csrfCookieName = _ref11.csrfCookieName,
      csrfCookieName = _ref11$csrfCookieName === void 0 ? '__janus_login_csurf_prod__' : _ref11$csrfCookieName;

  return function (cookieValue) {
    return (janusLoginServerCsrfCookieName || csrfCookieName) && cookieValue ? {
      'X-Csrf-Token': cookieValue
    } : {};
  }(cookies.get(janusLoginServerCsrfCookieName) || cookies.get(csrfCookieName));
};

var forwardSlash = function forwardSlash(path) {
  return _.startsWith(path, '/') ? path : "/".concat(path);
};

var smartUrl = function smartUrl(path) {
  var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      baseUrl = _ref12.baseUrl,
      racker = _ref12.racker;

  return _.startsWith(path, 'http') ? path : "".concat(baseUrl).concat(forwardSlash(audience({
    racker: racker
  }))).concat(forwardSlash(path));
};

var safeParseBody = _.identity;

var computeHeaders = function computeHeaders() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _.merge({}, config.domainId ? {
    'x-domain-id': config.domainId
  } : {}, config.tenantId ? {
    'x-tenant-id': config.tenantId
  } : {});
};

var computeUserAgent = function computeUserAgent(config) {
  return config.userAgent || "janus-ui-".concat(copilotLocation.pathname().split('/')[0]);
};

var computeJanusUi = function computeJanusUi(config) {
  return config.janusUi || "janus-ui-".concat(copilotLocation.pathname().split('/')[0]);
};

var computeBaseUrl = function computeBaseUrl(config) {
  return config.baseUrl || copilotLocation.origin();
};

var computeCsrfCookieName = function computeCsrfCookieName(config) {
  return config.janusLoginServerCsrfCookieName || config.csrfCookieName || '__janus_login_csurf_prod__';
};

var withDefaultOptions = function withDefaultOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _.merge({
    credentials: config.credentials || 'same-origin',
    method: 'GET',
    headers: _objectSpread({}, csrfCookieHeaders(config), computeHeaders(config), {
      'X-Janus-UI': _.get(config, 'janusUi', 'janus-copilot'),
      'X-Janus-UI-Version': _.get(config, 'sha', 'local'),
      'X-Janus-UI-Request-Id': v4(),
      'User-Agent': _.get(config, 'userAgent', 'janus-copilot'),
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    })
  }, _.pick(config, ['credentials']), options);
};

var enhanceOptions = _.flow([withDefaultOptions, withSafeBody]);

var enhanceConfig = function enhanceConfig(config) {
  return _.merge({
    userAgent: computeUserAgent(config),
    janusUi: computeJanusUi(config),
    csrfCookieName: computeCsrfCookieName(config),
    racker: config.racker || false,
    baseUrl: computeBaseUrl(config),
    loginOnUnauthorized: true,
    loginOnForbidden: false,
    loginUrl: loginUrl()
  }, config);
};

var proxyFetch = function proxyFetch(url$$1) {
  var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var configOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = enhanceConfig(configOptions);
  var options = enhanceOptions(fetchOptions, config);

  var requestId = _.get(options, 'headers.X-Janus-UI-Request-Id');

  return fetch(fromJanusUiToJanusLogin(url$$1), options).then(_.partial(enhanceResponse, {
    requestId: requestId
  })).then(_.partial(reportIfNeeded, {
    url: url$$1,
    requestId: requestId,
    config: config,
    fetchOptions: fetchOptions
  })).then(_.partial(checkForUnauthorized, {
    requestId: requestId,
    config: config
  })).then(_.partial(checkForForbidden, {
    requestId: requestId,
    config: config
  })).then(_.partial(rejectIfNeeded, {
    url: url$$1,
    requestId: requestId,
    config: config,
    fetchOptions: fetchOptions
  })).catch(_.partial(handleError, {
    url: url$$1,
    requestId: requestId,
    config: config
  }, options));
};

var fetchWithOptions = _.memoize(function (fetchOptions) {
  var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      baseUrl = _ref13.baseUrl,
      racker = _ref13.racker,
      copilotOptions = _objectWithoutProperties(_ref13, ["baseUrl", "racker"]);

  return function (url$$1, options, config) {
    return proxyFetch(smartUrl(url$$1, {
      baseUrl: baseUrl,
      racker: racker
    }), _.merge({}, fetchOptions, options), _.merge({}, copilotOptions, {
      baseUrl: baseUrl,
      racker: racker
    }, config)).then(safeParseBody);
  };
}, function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return safeStringify(args);
});

var useProxyFetch = function useProxyFetch() {
  var config = _.get(React.useContext(context.configuration), 'config', {});

  return fetchWithOptions({}, config);
};
proxyFetch.createLoginUrl = createLoginUrl;
proxyFetch.redirectToLogin = redirectToLogin;
proxyFetch.createBaseLoginUrlWithAudience = createBaseLoginUrlWithAudience;

var janusLogin = /*#__PURE__*/Object.freeze({
  createBaseLoginUrlWithAudience: createBaseLoginUrlWithAudience,
  createLoginUrl: createLoginUrl,
  redirectToLogin: redirectToLogin,
  proxyFetch: proxyFetch,
  useProxyFetch: useProxyFetch,
  default: proxyFetch
});

var hangingPromiseToWaitForRedirect$1 = function hangingPromiseToWaitForRedirect() {
  return new Promise(_.noop);
};

var defaultPrefix = function defaultPrefix(config) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : copilotLocation.pathname();
  return config.racker || /\/racker(\/|$)/i.test(pathname) ? 'racker' : 'aws';
};

var loginUrl$1 = function loginUrl(config, baseUrl) {
  return "".concat(baseUrl || copilotLocation.origin(), "/").concat(defaultPrefix(config || {}), "/login");
};

var handleLoginRedirects$1 = function handleLoginRedirects(shouldRedirect, errorName, config, error) {
  var baseUrl = _.get(config, 'baseUrl');

  if (shouldRedirect && error.name === errorName) {
    var query = ["cloud=".concat(config.cloud || 'aws'), "destination=".concat(encodeURIComponent(copilotLocation.href())), "invalidateCache=".concat(+Date.now())].join('&');
    copilotLocation.replace("".concat(loginUrl$1(config, baseUrl), "?").concat(query));
    return hangingPromiseToWaitForRedirect$1();
  }

  return null;
};

var handleUnauthorized$1 = function handleUnauthorized(config, error) {
  var loginOnUnauthorized = _.get(config, 'loginOnUnauthorized');

  return handleLoginRedirects$1(loginOnUnauthorized, 'Unauthorized', config, error);
};

var handleForbidden$1 = function handleForbidden(config, error) {
  var loginOnForbidden = _.get(config, 'loginOnForbidden');

  return handleLoginRedirects$1(loginOnForbidden, 'Forbidden', config, error);
};

var verrorFrom$1 = function verrorFrom(_ref) {
  var url = _ref.url,
      requestId = _ref.requestId,
      config = _ref.config,
      fetchOptions = _ref.fetchOptions,
      res = _ref.res,
      error = _ref.error;

  var errorMessage = _.get(config, 'errorMessage', 'Something Went Wrong');

  var errorName = _.get(config, 'errorName', 'InvalidResponse');

  return new VError({
    name: errorName,
    info: {
      url: url,
      requestId: requestId,
      method: fetchOptions.method,
      status: _.get(res, 'status', '-')
    },
    cause: _.isError(error) ? error : new Error("".concat(error))
  }, errorMessage);
};

var genericError$1 = function genericError(_ref2) {
  var config = _ref2.config,
      url = _ref2.url,
      requestId = _ref2.requestId,
      fetchOptions = _ref2.fetchOptions,
      error = _ref2.error;

  var errorName = _.get(config, 'errorName', 'NetworkFailure');

  var verror = verrorFrom$1({
    url: url,
    requestId: requestId,
    config: _objectSpread({}, config, {
      errorName: errorName
    }),
    fetchOptions: fetchOptions,
    error: error
  });
  var sentry = sentryClientForConfiguration(config);
  sentry.withScope(function (scope) {
    scope.setExtras(VError.info(verror));
    sentry.captureException(verror);
  });
  return Promise.reject(verror);
};

var invalidStatus$1 = function invalidStatus(target) {
  return function (_ref3) {
    var status = _ref3.status;
    return [].concat(target).indexOf(status) >= 0 && target;
  };
};

var reportIfNeeded$1 = function reportIfNeeded(_ref4, res) {
  var url = _ref4.url,
      requestId = _ref4.requestId,
      config = _ref4.config,
      fetchOptions = _ref4.fetchOptions;

  var reportOn = _.get(config, 'reportOn', function () {
    return false;
  });

  var reportOnFn = _.isFunction(reportOn) ? reportOn : invalidStatus$1(reportOn);
  var error = reportOnFn(res);

  if (error) {
    var verror = verrorFrom$1({
      url: url,
      requestId: requestId,
      config: config,
      fetchOptions: fetchOptions,
      res: res,
      error: error
    });
    var sentry = sentryClientForConfiguration(config);
    sentry.withScope(function (scope) {
      scope.setExtras(VError.info(verror));
      sentry.captureException(verror);
    });
  }

  return res;
};

var rejectIfNeeded$1 = function rejectIfNeeded(_ref5, res) {
  var url = _ref5.url,
      requestId = _ref5.requestId,
      config = _ref5.config,
      fetchOptions = _ref5.fetchOptions;

  var rejectOn = _.get(config, 'rejectOn', function () {
    return false;
  });

  var rejectOnFn = _.isFunction(rejectOn) ? rejectOn : invalidStatus$1(rejectOn);
  var error = rejectOnFn(res);

  if (error) {
    var verror = verrorFrom$1({
      url: url,
      requestId: requestId,
      config: config,
      fetchOptions: fetchOptions,
      res: res,
      error: error
    });
    return Promise.reject(verror);
  }

  return res;
};

var handleError$1 = function handleError(_ref6, fetchOptions, error) {
  var url = _ref6.url,
      requestId = _ref6.requestId,
      config = _ref6.config;
  return handleUnauthorized$1(config, error) || handleForbidden$1(config, error) || genericError$1({
    url: url,
    requestId: requestId,
    config: config,
    fetchOptions: fetchOptions,
    error: error
  });
};

var handleJsonResponse$1 = function handleJsonResponse(_ref7, res) {
  var requestId = _ref7.requestId;
  return res.text().then(function (rawResponseBody) {
    try {
      return Promise.resolve(JSON.parse(rawResponseBody));
    } catch (errorParsingJson) {
      return Promise.reject(new VError({
        cause: errorParsingJson,
        name: 'InvalidJSON',
        info: _objectSpread({
          requestId: requestId,
          rawResponseBody: rawResponseBody
        }, _.pick(res, ['status', 'url', 'ok', 'redirected']))
      }, 'Something went wrong'));
    }
  });
};

var enhanceResponse$1 = function enhanceResponse(_ref8, res) {
  var requestId = _ref8.requestId;
  res.requestId = requestId;
  res.parseJson = _.partial(handleJsonResponse$1, {
    requestId: requestId
  }, res);
  return res;
};

var checkForUnauthorized$1 = function checkForUnauthorized(_ref9, res) {
  var requestId = _ref9.requestId,
      config = _ref9.config;

  if (res.status !== 401 || _.get(config, 'ignoreUnauthorized') || !_.get(config, 'loginOnUnauthorized')) {
    return Promise.resolve(res);
  }

  return Promise.reject(new VError({
    name: 'Unauthorized',
    info: _objectSpread({
      requestId: requestId
    }, _.pick(res, ['status', 'url', 'ok', 'redirected']))
  }));
};

var checkForForbidden$1 = function checkForForbidden(_ref10, res) {
  var requestId = _ref10.requestId,
      config = _ref10.config;

  if (res.status !== 403 || _.get(config, 'ignoreForbidden') || !_.get(config, 'loginOnForbidden')) {
    return Promise.resolve(res);
  }

  return Promise.reject(new VError({
    name: 'Forbidden',
    info: _objectSpread({
      requestId: requestId
    }, _.pick(res, ['status', 'url', 'ok', 'redirected']))
  }));
};

var withSafeBody$1 = function withSafeBody() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return options.body ? _.merge(options, {
    body: _.isString(options.body) ? options.body : safeStringify(options.body)
  }) : options;
};

var csrfCookieHeaders$1 = function csrfCookieHeaders(_ref11) {
  var csrfCookieName = _ref11.csrfCookieName;
  return function (cookieValue) {
    return csrfCookieName && cookieValue ? {
      'X-Csrf-Token': cookieValue
    } : {};
  }(cookies.get(csrfCookieName));
};

var withDefaultOptions$1 = function withDefaultOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _.merge({
    credentials: 'same-origin',
    method: 'GET',
    headers: _objectSpread({}, csrfCookieHeaders$1(config), {
      'X-Janus-UI': _.get(config, 'janusUi', 'janus-copilot'),
      'X-Janus-UI-Version': _.get(config, 'sha', 'local'),
      'X-Janus-UI-Request-Id': v4(),
      'User-Agent': _.get(config, 'userAgent', 'janus-copilot'),
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    })
  }, _.pick(config, ['credentials']), options);
};

var enhanceOptions$1 = _.flow([withDefaultOptions$1, withSafeBody$1]);

var enhanceConfig$1 = function enhanceConfig(config) {
  return _.merge({
    loginOnUnauthorized: true,
    loginOnForbidden: false,
    loginUrl: loginUrl$1()
  }, config);
};

var proxyFetch$1 = function proxyFetch$$1(url) {
  var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var configOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = enhanceConfig$1(configOptions);
  var options = enhanceOptions$1(fetchOptions, config);

  var requestId = _.get(options, 'headers.X-Janus-UI-Request-Id');

  var useJanusLogin = _.get(config, 'useJanusLogin', false);

  return useJanusLogin ? proxyFetch(url, fetchOptions, configOptions) : fetch(url, options).then(_.partial(enhanceResponse$1, {
    requestId: requestId
  })).then(_.partial(reportIfNeeded$1, {
    url: url,
    requestId: requestId,
    config: config,
    fetchOptions: fetchOptions
  })).then(_.partial(checkForUnauthorized$1, {
    requestId: requestId,
    config: config
  })).then(_.partial(checkForForbidden$1, {
    requestId: requestId,
    config: config
  })).then(_.partial(rejectIfNeeded$1, {
    url: url,
    requestId: requestId,
    config: config,
    fetchOptions: fetchOptions
  })).catch(_.partial(handleError$1, {
    url: url,
    requestId: requestId,
    config: config
  }, options));
};
proxyFetch$1.janusLogin = janusLogin;

var pilotOptsPrefix = 'pilot.';

var urlParams = function urlParams() {
  return new URLSearchParams(copilotLocation.search());
};

var pilotEndpoint = function pilotEndpoint(configuration) {
  return _.get(configuration, 'featureFlags.pilotTest') ? 'pilot-test' : 'pilot';
};

var pilotOpts = function pilotOpts(configuration) {
  return _.chain(Array.from(urlParams().entries())).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return _.startsWith(k, pilotOptsPrefix) && k.length > pilotOptsPrefix.length;
  }).transform(function (r, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        k = _ref4[0],
        v = _ref4[1];

    r[k.slice(pilotOptsPrefix.length)] = v || '';
  }, _.get(configuration, 'pilotOptions', {})).value();
};

var themePilotOption = function themePilotOption(configuration) {
  return _.get(pilotOpts(configuration), 'theme');
};

var pilotContainerClassName = function pilotContainerClassName(configuration) {
  return _.thru(themePilotOption(configuration), function (theme) {
    return "janus-pilot--".concat(theme);
  });
};

var pilotOptionsQueryString = function pilotOptionsQueryString(configuration) {
  return _.chain(pilotOpts(configuration)).toPairs().transform(function (r, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        k = _ref6[0],
        v = _ref6[1];

    r.set(k, v);
  }, new URLSearchParams()).thru(function (v) {
    return v.toString();
  }).thru(function (v) {
    return v ? "?".concat(v) : '';
  }).value();
};

var PilotContainer = React.memo(function (props) {
  return React.createElement("div", {
    id: "janus-pilot",
    className: pilotContainerClassName(props.configuration)
  });
});
PilotContainer.displayName = 'PilotContainer';

var addPilotToDom = function addPilotToDom(selector) {
  return function (pilot) {
    var container = copilotDocument.querySelector(selector);

    if (!container) {
      return;
    }

    if (container.hasChildNodes()) {
      container.innerHTML = pilot;
    } else {
      container.appendChild(copilotDocument.createRange().createContextualFragment(pilot));
    }
  };
};

var pilotConfig = function pilotConfig() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cloud = _ref7.cloud,
      navSection = _ref7.navSection;

  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      useJanusLogin = _ref8.useJanusLogin;

  return {
    'primary-nav': {
      show: false
    },
    'utility-nav': {
      portfolio: {
        section: navSection || _.get({
          aws: 'faws',
          gcp: 'gcp',
          azure: 'azure',
          vmware: 'vmware'
        }, cloud, 'faws')
      }
    },
    logout: {
      uri: useJanusLogin ? '/logout/c' : '/aws/logout'
    }
  };
};

var pilotUrl = function pilotUrl(baseUrl, configuration) {
  return "".concat(baseUrl, "/aws/api/").concat(pilotEndpoint(configuration), "/v1/cloud/:rackspaceAccountNumber/navigation").concat(pilotOptionsQueryString(configuration));
};

var catchPilotError = function catchPilotError(configuration) {
  return function (error) {
    var verror = new VError({
      name: 'PilotFailure',
      cause: error
    });
    var sentry = sentryClientForConfiguration(configuration);
    sentry.withScope(function (scope) {
      scope.setExtras(VError.info(verror));
      sentry.captureException(verror);
    });
  };
};

var fetchPilot = function fetchPilot(_ref9) {
  var baseUrl = _ref9.baseUrl,
      configuration = _ref9.configuration,
      signal = _ref9.signal,
      rest = _objectWithoutProperties(_ref9, ["baseUrl", "configuration", "signal"]);

  return proxyFetch$1(pilotUrl(baseUrl, configuration), {
    method: 'POST',
    body: pilotConfig(rest, configuration)
  }, configuration).then(_.method('text')).then(addPilotToDom('#janus-pilot'));
};

var staticPilotUrl = function staticPilotUrl(cloud) {
  var filename = _.get({
    aws: 'faws',
    faws: 'faws',
    gcp: 'gcp',
    azure: 'azure',
    vmware: 'vmc'
  }, cloud, 'faws');

  return "https://dlp3xg0a726x4.cloudfront.net/default-headers/".concat(filename, ".html");
};

var fetchStaticPilot = function fetchStaticPilot(_ref10) {
  var configuration = _ref10.configuration,
      cloud = _ref10.cloud,
      navSection = _ref10.navSection;
  return fetch(staticPilotUrl(navSection || cloud), {
    method: 'GET'
  }).then(_.method('text')).then(addPilotToDom('#janus-pilot')).catch(catchPilotError(configuration));
};

var fallbackToStaticPilotAfterTimeout = function fallbackToStaticPilotAfterTimeout() {
  return new Promise(function (resolve, reject) {
    return setTimeout(reject, 5000);
  });
};

var renderPilot = function renderPilot() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      baseUrl = _ref11.baseUrl,
      configuration = _ref11.configuration,
      rest = _objectWithoutProperties(_ref11, ["baseUrl", "configuration"]);

  return Promise.race([fetchPilot(_objectSpread({
    baseUrl: baseUrl,
    configuration: configuration
  }, rest)), fallbackToStaticPilotAfterTimeout({
    configuration: configuration
  })]).catch(function (error) {
    catchPilotError(configuration)(error);
    fetchStaticPilot(_objectSpread({
      configuration: configuration
    }, rest));
  });
}; // eslint-disable-next-line no-console


var pilotGlobalNavEventHandler = function pilotGlobalNavEventHandler(e) {
  return console.log('pilot loaded', e);
};

var CustomerUtilityNavigation = function CustomerUtilityNavigation(props) {
  var catalogConfiguration = React.useContext(context.catalogConfiguration);
  var configuration = useConfiguration(catalogConfiguration, props);
  var cloud = useConfigurationValue('cloud', configuration, 'aws');
  var rackspaceAccountNumber = useConfigurationValue('rackspaceAccountNumber', configuration);
  var baseUrl = useConfigurationValue('baseUrl', configuration, copilotLocation.origin());
  var navSection = useConfigurationValue('navSection', configuration);

  var fetchConfiguration = _.merge({}, configuration, {
    rejectOn: function rejectOn(_ref12) {
      var status = _ref12.status;
      return status >= 400 && new VError({
        name: 'PilotFailure'
      });
    },
    loginOnForbidden: true,
    useJanusLogin: props.useJanusLogin
  });

  React.useEffect(function () {
    renderPilot({
      baseUrl: baseUrl,
      cloud: cloud,
      navSection: navSection,
      rackspaceAccountNumber: rackspaceAccountNumber,
      configuration: fetchConfiguration
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cloud, rackspaceAccountNumber, baseUrl]);
  React.useEffect(function () {
    var handler = _.get(configuration, 'featureFlags.pilotTest') ? pilotGlobalNavEventHandler : _.noop;
    global.document.addEventListener('pilotGlobalNavLoaded', handler);
    return function () {
      return global.document.removeEventListener('pilotGlobalNavLoaded', handler);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [false]);
  return React.createElement(PilotContainer, {
    configuration: configuration
  });
};

CustomerUtilityNavigation.displayName = 'CustomerUtilityNavigation';

var RackerUtilityNavigation = function RackerUtilityNavigation(props) {
  var responsive = useConfigurationValue('featureFlags.responsive', props);
  return responsive ? React.createElement(Responsive.UtilityNavigation, props) : React.createElement(Navigation, {
    className: "copilot-racker-utility-navigation"
  }, React.createElement(Navigation.Utility, null, area(_objectSpread({}, props, {
    navigationType: 'utility',
    area: 'logo'
  })), React.createElement(Navigation.Menu, {
    utility: true
  }, area(_objectSpread({}, props, {
    navigationType: 'utility',
    area: 'left'
  }))), React.createElement(Navigation.Menu, {
    utility: true,
    right: true
  }, area(_objectSpread({}, props, {
    navigationType: 'utility',
    area: 'right'
  })), React.createElement(Navigation.Separator, null), area(_objectSpread({}, props, {
    navigationType: 'utility',
    area: 'session'
  })))));
};

RackerUtilityNavigation.displayName = 'RackerUtilityNavigation';
var UtilityNavigation$1 = function UtilityNavigation$$1(props) {
  var _$merge = _.merge({}, React.useContext(context.catalogConfiguration), props),
      racker = _$merge.racker;

  return racker ? React.createElement(RackerUtilityNavigation, props) : React.createElement(CustomerUtilityNavigation, props);
};
UtilityNavigation$1.displayName = 'UtilityNavigation';

var UtilityNavigationWithJanusLogin = function UtilityNavigationWithJanusLogin(props) {
  return React.createElement(UtilityNavigation$1, _extends({
    useJanusLogin: true
  }, props));
};

UtilityNavigationWithJanusLogin.displayName = 'UtilityNavigationWithJanusLogin';
UtilityNavigation$1.janusLogin = {
  UtilityNavigation: UtilityNavigationWithJanusLogin
};

var ContextNavigation$1 = function ContextNavigation$$1(props) {
  var responsive = useConfigurationValue('featureFlags.responsive', props);
  return responsive ? React.createElement(Responsive.ContextNavigation, props) : React.createElement(Navigation, null, React.createElement(Navigation.Context, null, React.createElement(Navigation.Menu, null, area(_objectSpread({}, props, {
    navigationType: 'context',
    area: 'left'
  }))), React.createElement(Navigation.Menu, {
    right: true
  }, area(_objectSpread({}, props, {
    navigationType: 'context',
    area: 'right'
  })))));
};
ContextNavigation$1.displayName = 'ContextNavigation';

var NavigationContextProvider = function NavigationContextProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var topLevel = React.useContext(context.navigation);

  var _React$useState = React.useState(props),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentLevel = _React$useState2[0],
      setCurrentLevel = _React$useState2[1];

  var value = _.merge({}, topLevel, currentLevel, {
    setNavigationContext: _.get(topLevel, 'setNavigationContext') || setCurrentLevel
  });

  return children ? React.createElement(context.navigation.Provider, {
    value: _objectSpread({}, value)
  }, children) : null;
};
NavigationContextProvider.displayName = 'NavigationContextProvider';

var UtilityPlaceholder = function UtilityPlaceholder() {
  return React.createElement(Navigation.Utility, {
    className: "placeholder-navigation"
  }, React.createElement(Navigation.Menu, null, React.createElement(Navigation.Logo, null, "Janus")), React.createElement(Navigation.Menu, null, React.createElement(Navigation.Link, null, "AWS"), React.createElement(Navigation.Link, null, "Azure"), React.createElement(Navigation.Link, null, "GCP")), React.createElement(Navigation.Menu, {
    right: true
  }, React.createElement(Navigation.Link, null, "Ops Portal"), React.createElement(Navigation.Link, null, "Documentation"), React.createElement(Navigation.Separator, null), React.createElement(Navigation.Link, null, "Current User")));
};

UtilityPlaceholder.displayName = 'UtilityPlaceholder';

var ContextPlaceholder = function ContextPlaceholder() {
  return React.createElement(Navigation.Context, {
    className: "placeholder-navigation"
  }, React.createElement(Navigation.Menu, null, React.createElement(Navigation.Text, {
    className: "janus-particles-defect-rackspace-account-style"
  }, "Rackspace Account")), React.createElement(Navigation.Menu, {
    right: true
  }, React.createElement(Navigation.Text, null, "Payer Information")));
};

ContextPlaceholder.displayName = 'ContextPlaceholder';

var PrimaryPlaceholder = function PrimaryPlaceholder() {
  return React.createElement(Navigation.Primary, {
    className: "placeholder-navigation"
  }, React.createElement(Navigation.Menu, {
    primary: true
  }, React.createElement(Navigation.Link, {
    primary: true
  }, "Accounts"), React.createElement(Navigation.Link, {
    primary: true
  }, "Projects"), React.createElement(Navigation.Link, {
    primary: true
  }, "Subscriptions"), React.createElement(Navigation.Link, {
    primary: true
  }, "Pricing"), React.createElement(Navigation.Link, {
    primary: true
  }, "Usage"), React.createElement(Navigation.Link, {
    primary: true
  }, "Passport")));
};

PrimaryPlaceholder.displayName = 'PrimaryPlaceholder';
var PlaceholderNavigation = function PlaceholderNavigation(_ref) {
  var context = _ref.context,
      primary = _ref.primary,
      utility = _ref.utility,
      rest = _objectWithoutProperties(_ref, ["context", "primary", "utility"]);

  var responsive = useConfigurationValue('featureFlags.responsive', rest);
  return responsive ? null : React.createElement(React.Fragment, null, utility && React.createElement(UtilityPlaceholder, null), context && React.createElement(ContextPlaceholder, null), primary && React.createElement(PrimaryPlaceholder, null));
};
PlaceholderNavigation.displayName = 'PlaceholderNavigation';

var catalogKeyForRackers = function catalogKeyForRackers(_ref) {
  var root = _ref.root,
      cloud = _ref.cloud,
      userId = _ref.userId,
      rackspaceAccountNumber = _ref.rackspaceAccountNumber;
  return rackspaceAccountNumber && !root ? "janus-catalog/".concat(cloud, "/racker/").concat(userId, "/").concat(rackspaceAccountNumber) : "janus-catalog/".concat(cloud, "/racker/").concat(userId);
};

var catalogKeyForCustomers = function catalogKeyForCustomers(_ref2) {
  var cloud = _ref2.cloud,
      userId = _ref2.userId,
      rackspaceAccountNumber = _ref2.rackspaceAccountNumber;
  return "janus-catalog/".concat(cloud, "/").concat(rackspaceAccountNumber, "/").concat(userId);
};

var catalogKey = function catalogKey(_ref3) {
  var root = _ref3.root,
      cloud = _ref3.cloud,
      userId = _ref3.userId,
      rackspaceAccountNumber = _ref3.rackspaceAccountNumber,
      racker = _ref3.racker;
  return racker ? catalogKeyForRackers({
    root: root,
    cloud: cloud,
    userId: userId,
    rackspaceAccountNumber: rackspaceAccountNumber
  }) : catalogKeyForCustomers({
    cloud: cloud,
    userId: userId,
    rackspaceAccountNumber: rackspaceAccountNumber
  });
};

var missingCatalogError = function missingCatalogError() {
  return new VError({
    name: 'MissingCatalog'
  }, "Catalog is required and must be populated in localStorage. See racker/janus-copilot README for configuration details");
};
var missingLinksError = function missingLinksError() {
  return new VError({
    name: 'InvalidCatalog'
  }, "catalog is invalid, missing catalog.(context|primary|utility)Navigation.links - are you using the correct version of racker/janus-copilot?");
};
var duplicatedRelError = function duplicatedRelError(linkA, linkB) {
  return new VError({
    name: 'InvalidCatalog'
  }, "catalog is invalid, duplicated link.rel [".concat(safeStringify(linkA), "] [").concat(safeStringify(linkB), "]"));
};
var missingRelError = function missingRelError(link) {
  return new VError({
    name: 'InvalidCatalog'
  }, "catalog is invalid, missing link.rel [".concat(safeStringify(link), "]"));
};

var populateCatalog = function populateCatalog(_ref) {
  var onCatalogError = _ref.onCatalogError,
      rest = _objectWithoutProperties(_ref, ["onCatalogError"]);

  return function (catalog) {
    var key = catalogKey(rest);

    try {
      global.localStorage.setItem(catalogKey(rest), safeStringify(catalog));
    } catch (error) {
      var sentry = sentryClientForConfiguration(rest);
      var verror = new VError({
        name: 'LocalStorageWriteError',
        info: {
          key: key
        },
        cause: error
      });
      sentry.withScope(function (scope) {
        scope.setExtras(VError.info(verror));
        sentry.captureException(verror);
      });
      onCatalogError('could not store catalog:', verror);
    } finally {
      return catalog;
    }
  };
};

var catalogIsPresent = function catalogIsPresent(_ref2, raw) {
  var onMissingCatalog = _ref2.onMissingCatalog,
      configuration = _objectWithoutProperties(_ref2, ["onMissingCatalog"]);

  if (!_.some(raw)) {
    onMissingCatalog(configuration);
    throw missingCatalogError(raw);
  }

  return true;
};

var catalogContainsLinks = function catalogContainsLinks(parsed) {
  if (!_.some(_.get(parsed, 'catalog.contextNavigation.links')) && !_.some(_.get(parsed, 'catalog.utilityNavigation.links')) && !_.some(_.get(parsed, 'catalog.primaryNavigation.links'))) {
    throw missingLinksError();
  }

  return true;
};

var catalogContainsNoDuplicatedRel = function catalogContainsNoDuplicatedRel(parsed) {
  return _.thru(_.concat(_.get(parsed, 'catalog.contextNavigation.links'), _.get(parsed, 'catalog.utilityNavigation.links'), _.get(parsed, 'catalog.primaryNavigation.links')), function (allRels) {
    return _.reduce(_.compact(_.orderBy(allRels, ['rel'])), function (previous, current) {
      if (!current.rel) {
        throw missingRelError(current);
      }

      if (previous.rel === current.rel) {
        throw duplicatedRelError(current, previous);
      }

      return current;
    }, {
      rel: null
    });
  });
};

var validCatalog = function validCatalog(configuration, raw) {
  return catalogIsPresent(configuration, raw) && _.thru(JSON.parse(raw), function (parsed) {
    return catalogContainsLinks(parsed) && catalogContainsNoDuplicatedRel(parsed) && parsed;
  });
};

var parseCatalog = function parseCatalog(_ref3, raw) {
  var onCatalogError = _ref3.onCatalogError,
      configuration = _objectWithoutProperties(_ref3, ["onCatalogError"]);

  try {
    return validCatalog(configuration, raw);
  } catch (error) {
    var verror = new VError({
      name: _.some(raw) ? 'InvalidCatalog' : 'MissingCatalog',
      info: {
        key: catalogKey(configuration)
      },
      cause: error
    });

    if (_.some(raw)) {
      var sentry = sentryClientForConfiguration(configuration);
      sentry.withScope(function (scope) {
        scope.setExtras(VError.info(verror));
        sentry.captureException(verror);
      });
    }

    onCatalogError('invalid catalog:', raw, verror);
    return null;
  }
};

var readFromLocalStorage = function readFromLocalStorage(catalogConfiguration) {
  var key = catalogKey(catalogConfiguration);

  try {
    return global.localStorage.getItem(key);
  } catch (error) {
    var verror = new VError({
      name: 'LocalStorageReadError',
      info: {
        key: key
      },
      cause: error
    });
    var sentry = sentryClientForConfiguration(catalogConfiguration);
    sentry.withScope(function (scope) {
      scope.setExtras(VError.info(verror));
      sentry.captureException(verror);
    });
    throw verror;
  }
};

var fromLocalStorage = function fromLocalStorage(catalogConfiguration) {
  return parseCatalog(catalogConfiguration, readFromLocalStorage(catalogConfiguration)) || null;
};

var sanitizedLocale = function sanitizedLocale(locale) {
  return _.find(['en-US', 'en-coffee', 'ja-JP', 'en', 'ja', 'en-us', 'ja-jp', 'en-Coffee'], function (entry) {
    return entry === locale;
  }) || 'en-US';
};

var fetchHeaders = function fetchHeaders(_ref4) {
  var root = _ref4.root,
      rackspaceAccountNumber = _ref4.rackspaceAccountNumber,
      racker = _ref4.racker,
      locale = _ref4.locale;
  return _objectSpread({}, !root && rackspaceAccountNumber && racker ? {
    'X-Tenant-Id': rackspaceAccountNumber
  } : {}, {
    'Accept-Language': sanitizedLocale(locale) !== 'en-US' ? "".concat(sanitizedLocale(locale), ";q=0.9, en-US;q=0.8, en;q=0.7, *;q=0.5") : "en-US;q=0.9, en;q=0.8, *;q=0.5"
  });
};

var LocalStorageCatalogDataProvider = function LocalStorageCatalogDataProvider(_ref5) {
  var children = _ref5.children;
  var catalogConfiguration = React.useContext(context.catalogConfiguration);

  var _React$useState = React.useState(fromLocalStorage(catalogConfiguration)),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      catalog = _React$useState2[0];

  return children(_objectSpread({
    catalog: catalog
  }, catalogConfiguration));
};

var handleFetchError = function handleFetchError(res) {
  return res.text().then(function (error) {
    return Promise.reject(new Error("http status ".concat(res.status, " while retrieving catalog. error: ").concat(error)));
  });
};

var fetchUrlSuffix = function fetchUrlSuffix(configuration) {
  return [_.get(configuration, 'featureFlags.translateJp', false) ? '&translateJp=true' : '', _.some(_.get(configuration, 'featureFlags.catalogApi')) ? "&".concat(qs.stringify(configuration.featureFlags.catalogApi)) : '', _.get(configuration, 'forceLocale', false) ? "&forceLocale=".concat(configuration.forceLocale) : ''].join('');
};

var rawFetchCatalog = function rawFetchCatalog(_ref6) {
  var root = _ref6.root,
      baseUrl = _ref6.baseUrl,
      racker = _ref6.racker,
      rackspaceAccountNumber = _ref6.rackspaceAccountNumber,
      credentials = _ref6.credentials,
      live = _ref6.live,
      cloud = _ref6.cloud,
      locale = _ref6.locale,
      configuration = _objectWithoutProperties(_ref6, ["root", "baseUrl", "racker", "rackspaceAccountNumber", "credentials", "live", "cloud", "locale"]);

  return proxyFetch$1("".concat(baseUrl, "/").concat(racker ? 'racker' : 'aws', "/copilot/catalog.json?cloud=").concat(cloud || 'aws').concat(fetchUrlSuffix(configuration)), {
    credentials: credentials,
    headers: fetchHeaders({
      racker: racker,
      root: root,
      rackspaceAccountNumber: rackspaceAccountNumber,
      locale: locale
    })
  }, _objectSpread({}, configuration, {
    racker: racker,
    baseUrl: baseUrl,
    loginOnForbidden: true
  })).then(function (res) {
    return res.ok ? res.parseJson() : handleFetchError(res);
  });
};

var fetchCatalogFunctionsStore = {};
var clearFetchCatalogFunctionsStore = function clearFetchCatalogFunctionsStore() {
  return _.forEach(fetchCatalogFunctionsStore, function (value, key) {
    return _.set(fetchCatalogFunctionsStore, key, null);
  });
};

var fetchFunctionKeyFor = function fetchFunctionKeyFor(_ref7) {
  var root = _ref7.root,
      racker = _ref7.racker,
      rackspaceAccountNumber = _ref7.rackspaceAccountNumber,
      locale = _ref7.locale;
  return safeStringify({
    root: root,
    racker: racker,
    rackspaceAccountNumber: rackspaceAccountNumber,
    locale: locale
  });
};

var existingFetchFunctionFor = function existingFetchFunctionFor() {
  return _.get(fetchCatalogFunctionsStore, fetchFunctionKeyFor.apply(void 0, arguments));
};

var throttledFetchFunction = function throttledFetchFunction(_ref8) {
  var fetchThrottleInMs = _ref8.fetchThrottleInMs;
  return _.throttle(rawFetchCatalog, fetchThrottleInMs, {
    trailing: false,
    leading: true
  });
};

var storeFetchFunction = function storeFetchFunction() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (fetchFunction) {
    return _.set(fetchCatalogFunctionsStore, fetchFunctionKeyFor.apply(void 0, args), fetchFunction);
  };
};

var fetchCatalogFunctionFor = function fetchCatalogFunctionFor() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var _$merge = _.merge({
    fetchThrottleInMs: 5 * 60 * 1000
  }, _.head(args)),
      fetchThrottleInMs = _$merge.fetchThrottleInMs;

  return fetchThrottleInMs <= 0 ? rawFetchCatalog : _.tap(existingFetchFunctionFor.apply(void 0, args) || throttledFetchFunction({
    fetchThrottleInMs: fetchThrottleInMs
  }), storeFetchFunction.apply(void 0, args));
};

var fetchCatalog = function fetchCatalog() {
  return fetchCatalogFunctionFor.apply(void 0, arguments).apply(void 0, arguments);
};

var ApiCatalogDataProvider = function ApiCatalogDataProvider(_ref9) {
  var children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["children"]);

  var catalogConfiguration = React.useContext(context.catalogConfiguration);
  var configuration = useConfiguration(catalogConfiguration, props);
  var useJanusLogin = useConfigurationValue('useJanusLogin', props, false);
  var onFetchError = catalogConfiguration.onFetchError,
      live = catalogConfiguration.live;

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      catalog = _React$useState4[0],
      setCatalog = _React$useState4[1];

  var fetchConfiguration = React.useMemo(function () {
    return _.merge({}, configuration, {
      useJanusLogin: useJanusLogin,
      rejectOn: function rejectOn(_ref10) {
        var status = _ref10.status;
        return status >= 400 && new VError({
          name: 'CatalogFetchFailure'
        });
      }
    });
  }, [useJanusLogin, configuration]);
  React.useEffect(function () {
    if (!live) {
      return;
    }

    var componentState = {
      unmounted: false
    };

    var ignoreIfUnmounted = function ignoreIfUnmounted(fn) {
      return function () {
        return componentState.unmounted || fn.apply(void 0, arguments);
      };
    };

    fetchCatalog(fetchConfiguration).then(ignoreIfUnmounted(populateCatalog(configuration))).then(ignoreIfUnmounted(setCatalog)).catch(ignoreIfUnmounted(onFetchError));
    return function () {
      return _.set(componentState, 'unmounted', true);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogConfiguration]);
  return children(_objectSpread({
    catalog: catalog
  }, catalogConfiguration));
};

ApiCatalogDataProvider.displayName = 'ApiCatalogDataProvider';
var DataProvider = function DataProvider(_ref11) {
  var children = _ref11.children,
      Provider = _ref11.context.Provider;
  var catalogConfiguration = React.useContext(context.catalogConfiguration);
  return React.createElement(LocalStorageCatalogDataProvider, null, function (catalogFromLocalStorage) {
    return React.createElement(ApiCatalogDataProvider, null, function (catalogFromApi) {
      return function (catalog) {
        return React.createElement(Provider, {
          value: catalog
        }, children(_objectSpread({
          catalog: catalog
        }, catalogConfiguration)));
      }(_.get(catalogFromApi, 'catalog') || _.get(catalogFromLocalStorage, 'catalog'));
    });
  });
};
DataProvider.displayName = 'DataProvider';

var targetContext = function targetContext(_ref) {
  var root = _ref.root,
      racker = _ref.racker,
      rackspaceAccountNumber = _ref.rackspaceAccountNumber;
  return !root && racker && rackspaceAccountNumber ? context.contextCatalog : context.rootCatalog;
};

var baseUrl = function baseUrl(_ref2) {
  var baseUrl = _ref2.baseUrl,
      fallbackBaseUrl = _ref2.fallbackBaseUrl;
  return baseUrl || fallbackBaseUrl || copilotLocation.origin();
};

var someFallbackStrategy = function someFallbackStrategy(_ref3) {
  var fallbackStrategy = _ref3.fallbackStrategy;
  return fallbackStrategy && fallbackStrategy !== 'none';
};

var contextCatalog = function contextCatalog(_ref4) {
  var root = _ref4.root,
      racker = _ref4.racker,
      rackspaceAccountNumber = _ref4.rackspaceAccountNumber;
  return !root && racker && rackspaceAccountNumber;
};

var live = function live(_ref5) {
  var live = _ref5.live,
      noFetch = _ref5.noFetch,
      rest = _objectWithoutProperties(_ref5, ["live", "noFetch"]);

  return !noFetch && (live || someFallbackStrategy(rest) || contextCatalog(rest));
};

var onCatalogError = function onCatalogError(_ref6) {
  var onCatalogError = _ref6.onCatalogError;
  return onCatalogError || error;
};

var onMissingCatalog = function onMissingCatalog(_ref7) {
  var onMissingCatalog = _ref7.onMissingCatalog;
  return onMissingCatalog || error;
};

var credentials = function credentials(configuration) {
  return _.get(configuration, 'credentials') || 'same-origin';
};

var configurationContextValue = function configurationContextValue() {
  var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({}, configuration || {}, {
    onMissingCatalog: onMissingCatalog(configuration),
    onCatalogError: onCatalogError(configuration),
    live: live(configuration),
    baseUrl: baseUrl(configuration),
    credentials: credentials(configuration)
  });
};

var fallbackStrategyDeprecationWarning = function fallbackStrategyDeprecationWarning(_ref8) {
  var fallbackStrategy = _ref8.fallbackStrategy;
  return fallbackStrategy && warn("\n  <Catalog fallbackStrategy={...}> is deprecated. Use <Catalog live={true}> instead.\n");
};

var fallbackBaseUrlDeprecationWarning = function fallbackBaseUrlDeprecationWarning(_ref9) {
  var fallbackBaseUrl = _ref9.fallbackBaseUrl;
  return fallbackBaseUrl && warn("\n  <Catalog fallbackBaseUrl={...}> is deprecated. Use <Catalog baseUrl={...}> instead.\n");
};

var deprecationWarnings = function deprecationWarnings(configuration) {
  fallbackStrategyDeprecationWarning(configuration);
  fallbackBaseUrlDeprecationWarning(configuration);
};

var Catalog = function Catalog(_ref10) {
  var children = _ref10.children,
      placeholder = _ref10.placeholder,
      props = _objectWithoutProperties(_ref10, ["children", "placeholder"]);

  var configuration = useConfiguration(props);
  deprecationWarnings(configuration);
  return React.createElement(context.catalogConfiguration.Provider, {
    value: configurationContextValue(configuration)
  }, React.createElement(DataProvider, {
    context: targetContext(configuration)
  }, function (_ref11) {
    var catalog = _ref11.catalog,
        rest = _objectWithoutProperties(_ref11, ["catalog"]);

    return catalog ? children(_objectSpread({
      catalog: catalog
    }, rest)) : placeholder(_objectSpread({
      catalog: catalog
    }, rest));
  }));
};
Catalog.clearFetchCatalogFunctionsStore = clearFetchCatalogFunctionsStore;
Catalog.defaultProps = {
  children: function children() {
    return null;
  },
  fallbackStrategy: null,
  featureFlags: {
    catalogApi: {}
  },
  live: false,
  locale: 'en-US',
  noFetch: false,
  onFetchError: _.noop,
  placeholder: function placeholder() {
    return null;
  }
};
Catalog.displayName = 'Catalog';

var monitoredEvents = function monitoredEvents() {
  return ['keydown', 'wheel', 'mousedown', 'touchstart', 'touchmove', 'click'];
};

var registerActivityWith = function registerActivityWith(setActivity, userActivityDebounceDelay) {
  return _.debounce(function () {
    return setActivity(function (activity) {
      return _objectSpread({}, activity || {}, {
        lastActivity: Date.now()
      });
    });
  }, userActivityDebounceDelay, {
    leading: true,
    trailing: true,
    maxWait: userActivityDebounceDelay
  });
};

var ActivityMonitor = function ActivityMonitor(_ref) {
  var props = _extends({}, _ref);

  var proxyFetch = proxyFetch$1.janusLogin.useProxyFetch();

  var _React$useContext = React.useContext(context.session),
      session = _React$useContext.session;

  var _React$useContext2 = React.useContext(context.activity),
      setActivity = _React$useContext2.setActivity,
      activity = _React$useContext2.activity;

  var userActivityDebounceDelay = useConfigurationValue('userActivityDebounceDelayInSeconds', props, 60) * 1000;
  var configuration = useConfiguration(props, {
    loginOnUnauthorized: false,
    loginOnForbidden: false
  });
  var baseUrl = useConfigurationValue('baseUrl', props, copilotLocation.origin());
  var racker = useConfigurationValue('racker', props, _.some(_.get(session, 'user.roles'), {
    name: 'Racker'
  }));
  var sessionHeartbeatDebounceDelay = useConfigurationValue('sessionHeartbeatDebounceDelayInSeconds', props, 300) * 1000;
  var onHeartbeatSuccess = useConfigurationValue('onHeartbeatSuccess', props, _.noop);
  var onHeartbeatfailure = useConfigurationValue('onHeartbeatfailure', props, _.noop);
  var rootElement = useConfigurationValue('rootElement', props, copilotDocument.body);

  var fetchConfiguration = _.merge({}, configuration, {
    reportOn: function reportOn(_ref2) {
      var status = _ref2.status;
      return status >= 400 && [401, 403].indexOf(status) < 0 && new VError({
        name: 'HeartbeatFailure'
      });
    }
  });

  var userId = _.get(session, 'user.id');

  var sessionHeartbeatCallback = React.useCallback(_.debounce(function () {
    return userId && proxyFetch("".concat(baseUrl, "/login/").concat(racker ? 'r' : 'c', "/session-activity"), {
      method: 'GET'
    }, fetchConfiguration).then(function (_ref3) {
      var ok = _ref3.ok;
      return ok || Promise.reject(new Error('HeartbeatFailure'));
    }).then(onHeartbeatSuccess).catch(onHeartbeatfailure);
  }, sessionHeartbeatDebounceDelay, {
    leading: true,
    trailing: true,
    maxWait: sessionHeartbeatDebounceDelay
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [onHeartbeatSuccess, onHeartbeatfailure, racker, userId, sessionHeartbeatDebounceDelay]);
  var registerActivityCallback = React.useCallback(registerActivityWith(setActivity, userActivityDebounceDelay), [setActivity, userActivityDebounceDelay, userId]);
  React.useEffect(function () {
    _.forEach(monitoredEvents(), function (eventName) {
      return _.invoke(rootElement(), 'addEventListener', eventName, registerActivityCallback);
    });

    return function () {
      _.forEach(monitoredEvents(), function (eventName) {
        return _.invoke(rootElement(), 'removeEventListener', eventName, registerActivityCallback);
      });
    };
  }, [registerActivityCallback, rootElement]);
  React.useEffect(function () {
    sessionHeartbeatCallback();
  }, [activity.lastActivity, userId, sessionHeartbeatCallback]);
  return null;
};
ActivityMonitor.displayName = 'ActivityMonitor';
var ActivityProvider = function ActivityProvider(_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activity = _React$useState2[0],
      setActivity = _React$useState2[1];

  return React.createElement(context.activity.Provider, {
    value: {
      activity: activity,
      setActivity: setActivity
    }
  }, React.createElement(React.Fragment, null, React.createElement(ActivityMonitor, rest), React.createElement(ErrorBoundary, null, children)));
};
ActivityProvider.displayName = 'ActivityProvider';

var janusLogin$1 = /*#__PURE__*/Object.freeze({
  ActivityMonitor: ActivityMonitor,
  ActivityProvider: ActivityProvider
});

var monitoredEvents$1 = function monitoredEvents() {
  return ['keydown', 'wheel', 'mousedown', 'touchstart', 'touchmove', 'click'];
};

var registerActivityWith$1 = function registerActivityWith(setActivity, userActivityDebounceDelay) {
  return _.debounce(function () {
    return setActivity(function (activity) {
      return _objectSpread({}, activity || {}, {
        lastActivity: Date.now()
      });
    });
  }, userActivityDebounceDelay, {
    leading: true,
    trailing: true,
    maxWait: userActivityDebounceDelay
  });
};

var ActivityMonitor$1 = function ActivityMonitor$$1(_ref) {
  var props = _extends({}, _ref);

  var _React$useContext = React.useContext(context.session),
      session = _React$useContext.session;

  var _React$useContext2 = React.useContext(context.activity),
      setActivity = _React$useContext2.setActivity,
      activity = _React$useContext2.activity;

  var userActivityDebounceDelay = useConfigurationValue('userActivityDebounceDelayInSeconds', props, 60) * 1000;
  var configuration = useConfiguration(props, {
    loginOnUnauthorized: false,
    loginOnForbidden: false
  });
  var baseUrl = useConfigurationValue('baseUrl', props, copilotLocation.origin());
  var racker = useConfigurationValue('racker', props, _.some(_.get(session, 'user.roles'), {
    name: 'Racker'
  }));
  var sessionHeartbeatDebounceDelay = useConfigurationValue('sessionHeartbeatDebounceDelayInSeconds', props, 300) * 1000;
  var onHeartbeatSuccess = useConfigurationValue('onHeartbeatSuccess', props, _.noop);
  var onHeartbeatfailure = useConfigurationValue('onHeartbeatfailure', props, _.noop);
  var rootElement = useConfigurationValue('rootElement', props, copilotDocument.body);

  var fetchConfiguration = _.merge({}, configuration, {
    reportOn: function reportOn(_ref2) {
      var status = _ref2.status;
      return status >= 400 && [401, 403].indexOf(status) < 0 && new VError({
        name: 'HeartbeatFailure'
      });
    }
  });

  var userId = _.get(session, 'user.id');

  var sessionHeartbeatCallback = React.useCallback(_.debounce(function () {
    return userId && proxyFetch$1("".concat(baseUrl, "/").concat(racker ? 'racker' : 'aws', "/session-activity"), {
      method: 'POST'
    }, fetchConfiguration).then(function (_ref3) {
      var ok = _ref3.ok;
      return ok || Promise.reject(new Error('HeartbeatFailure'));
    }).then(onHeartbeatSuccess).catch(onHeartbeatfailure);
  }, sessionHeartbeatDebounceDelay, {
    leading: true,
    trailing: true,
    maxWait: sessionHeartbeatDebounceDelay
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [onHeartbeatSuccess, onHeartbeatfailure, racker, userId, sessionHeartbeatDebounceDelay]);
  var registerActivityCallback = React.useCallback(registerActivityWith$1(setActivity, userActivityDebounceDelay), [setActivity, userActivityDebounceDelay, userId]);
  React.useEffect(function () {
    _.forEach(monitoredEvents$1(), function (eventName) {
      return _.invoke(rootElement(), 'addEventListener', eventName, registerActivityCallback);
    });

    return function () {
      _.forEach(monitoredEvents$1(), function (eventName) {
        return _.invoke(rootElement(), 'removeEventListener', eventName, registerActivityCallback);
      });
    };
  }, [registerActivityCallback, rootElement]);
  React.useEffect(function () {
    sessionHeartbeatCallback();
  }, [activity.lastActivity, userId, sessionHeartbeatCallback]);
  return null;
};
ActivityMonitor$1.displayName = 'ActivityMonitor';
var ActivityProvider$1 = function ActivityProvider$$1(_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activity = _React$useState2[0],
      setActivity = _React$useState2[1];

  return React.createElement(context.activity.Provider, {
    value: {
      activity: activity,
      setActivity: setActivity
    }
  }, React.createElement(React.Fragment, null, React.createElement(ActivityMonitor$1, rest), React.createElement(ErrorBoundary, null, children)));
};
ActivityProvider$1.displayName = 'ActivityProvider';
ActivityProvider$1.janusLogin = janusLogin$1;

var useSafeState = function useSafeState() {
  var _React$useState = React.useState.apply(React, arguments),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      rawSetter = _React$useState2[1];

  var componentState = React.useRef({
    unmounted: false
  });
  var set = React.useCallback(function () {
    return !componentState.current.unmounted && rawSetter.apply(void 0, arguments);
  }, [rawSetter, componentState]);
  React.useEffect(function () {
    return function () {
      componentState.current.unmounted = true;
    };
  }, [componentState]);
  return React.useMemo(function () {
    return [state, set];
  }, [state, set]);
};

var setUserContext = function setUserContext(configuration) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        user = _ref.user,
        session = _ref.session;

    var sentry = sentryClientForConfiguration(configuration);
    sentry.configureScope(function (scope) {
      scope.setUser({
        id: _.get(user, 'id', '<unknown>'),
        username: _.get(session, 'saml.username') || _.get(user, 'username', '<unknown>'),
        email: _.get(user, 'email', '<unknown>'),
        tenant: _.get(user, 'RAX-AUTH:domainId') || _.get(configuration, 'rackspaceAccountNumber') || 'none'
      });
    });
  };
};

var useSessionFetch = function useSessionFetch(options) {
  var configuration = useConfiguration(options, {
    errorName: 'SessionFailure'
  });
  var errorName = useConfigurationValue('sessionErrorName', options, 'SessionFailure');
  var onSessionReady = useConfigurationValue('onSessionReady', options, _.noop);
  var onSessionFailure = useConfigurationValue('onSessionFailure', options, _.noop);
  var setSession = useConfigurationValue('setSession', options, _.noop);
  var fetchFn = proxyFetch$1.janusLogin.useProxyFetch();
  React.useEffect(function () {
    var fetchCopilotConfiguration = _.merge({}, configuration, {
      loginOnForbidden: true,
      loginOnUnauthorized: true,
      rejectOn: function rejectOn(_ref2) {
        var status = _ref2.status;
        return status >= 400 && new VError({
          name: errorName
        });
      }
    });

    var fetchOptions = {
      method: 'GET'
    };
    var fetchUrl = "".concat(proxyFetch$1.janusLogin.createBaseLoginUrlWithAudience(configuration), "/session");
    fetchFn(fetchUrl, fetchOptions, fetchCopilotConfiguration).then(function (_ref3) {
      var ok = _ref3.ok,
          parseJson = _ref3.parseJson;
      return ok ? parseJson() : Promise.reject(new Error('SessionFailure'));
    }).then(function (json) {
      return _.merge(json, {
        user: _.get(json, 'session.identity.access.user')
      });
    }).then(function (session) {
      setSession(session);
      setUserContext(configuration)(session);
    }).catch(function (error) {
      return onSessionFailure(error);
    });
  }, [fetchFn, configuration, setSession, errorName, onSessionFailure, onSessionReady]);
};

var useSession = function useSession() {
  return _.get(React.useContext(context.session), 'session');
};
var useUser = function useUser() {
  return _.get(useSession(), 'user');
};
var SessionProvider = function SessionProvider(_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  var _useSafeState = useSafeState({}),
      _useSafeState2 = _slicedToArray(_useSafeState, 2),
      session = _useSafeState2[0],
      setSession = _useSafeState2[1];

  useSessionFetch(_objectSpread({
    setSession: setSession
  }, rest));
  return React.createElement(context.session.Provider, {
    value: {
      session: session,
      setSession: setSession
    }
  }, React.createElement(React.Fragment, null, React.createElement(ErrorBoundary, null, children)));
};
SessionProvider.displayName = 'SessionProvider';

var janusLogin$2 = /*#__PURE__*/Object.freeze({
  useSession: useSession,
  useUser: useUser,
  SessionProvider: SessionProvider
});

var setUserContext$1 = function setUserContext(configuration) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        user = _ref.user;

    var sentry = sentryClientForConfiguration(configuration);
    sentry.configureScope(function (scope) {
      scope.setUser({
        id: _.get(user, 'id', '<unknown>'),
        username: _.get(user, 'username', '<unknown>'),
        email: _.get(user, 'email', '<unknown>'),
        tenant: _.get(user, 'RAX-AUTH:domainId') || _.get(configuration, 'rackspaceAccountNumber') || 'none'
      });
    });
  };
};

var SessionFetcher = function SessionFetcher(props) {
  var configuration = useConfiguration(props, {
    errorName: 'SessionFailure'
  });
  var onSessionReady = useConfigurationValue('onSessionReady', props, _.noop);
  var onSessionFailure = useConfigurationValue('onSessionFailure', props, _.noop);
  var setSession = useConfigurationValue('setSession', props, _.noop);
  var baseUrl = useConfigurationValue('baseUrl', props, copilotLocation.origin());
  var racker = useConfigurationValue('racker', props);

  var fetchConfiguration = _.merge({}, configuration, {
    loginOnForbidden: true,
    rejectOn: function rejectOn(_ref2) {
      var status = _ref2.status;
      return status >= 400 && new VError({
        name: 'SessionFailure'
      });
    }
  });

  React.useEffect(function () {
    var componentState = {
      mounted: true
    };

    var ignoreIfUnmounted = function ignoreIfUnmounted() {
      for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
      }

      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return componentState.mounted && _.map(fns, function (fn) {
          return (fn || _.noop).apply(void 0, args);
        });
      };
    };

    proxyFetch$1("".concat(baseUrl, "/").concat(racker ? 'racker' : 'aws', "/session"), {
      method: 'GET'
    }, fetchConfiguration).then(function (_ref3) {
      var ok = _ref3.ok,
          parseJson = _ref3.parseJson;
      return ok ? parseJson() : Promise.reject(new Error('SessionFailure'));
    }).then(ignoreIfUnmounted(setSession, onSessionReady, setUserContext$1(configuration))).catch(ignoreIfUnmounted(onSessionFailure));
    return function () {
      return _.set(componentState, 'mounted', false);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [false]);
  return null;
};
SessionFetcher.displayName = 'SessionFetcher';
var SessionProvider$1 = function SessionProvider$$1(_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      session = _React$useState2[0],
      setSession = _React$useState2[1];

  return React.createElement(context.session.Provider, {
    value: {
      session: session,
      setSession: setSession
    }
  }, React.createElement(React.Fragment, null, React.createElement(SessionFetcher, _extends({}, rest, {
    setSession: setSession
  })), React.createElement(ErrorBoundary, null, children)));
};
SessionProvider$1.displayName = 'SessionProvider';
SessionProvider$1.janusLogin = janusLogin$2;

var Pilot = React.memo(function (_ref) {
  var racker = _ref.racker;
  return racker ? null : React.createElement(UtilityNavigation$1.janusLogin.UtilityNavigation, null);
});
Pilot.displayName = 'Pilot';
var ContextCatalog = React.memo(function (_ref2) {
  var userId = _ref2.userId,
      racker = _ref2.racker,
      catalogOverrides = _ref2.catalogOverrides,
      rackspaceAccountNumber = _ref2.rackspaceAccountNumber,
      locale = _ref2.locale;
  return userId ? rackspaceAccountNumber && racker ? React.createElement(Catalog, {
    live: true,
    locale: locale,
    userId: userId,
    placeholder: function placeholder() {
      return React.createElement(PlaceholderNavigation, {
        context: true,
        primary: true
      });
    }
  }, function (contextCatalog) {
    return React.createElement(React.Fragment, null, React.createElement(ContextNavigation$1, catalogOverrides(contextCatalog)), React.createElement(PrimaryNavigation$1, catalogOverrides(contextCatalog)));
  }) : null : null;
});
ContextCatalog.displayName = 'ContextCatalog';
var RootCatalog = React.memo(function (_ref3) {
  var userId = _ref3.userId,
      racker = _ref3.racker,
      catalogOverrides = _ref3.catalogOverrides,
      locale = _ref3.locale;
  return userId ? React.createElement(Catalog, {
    live: true,
    root: true,
    locale: locale,
    userId: userId,
    placeholder: function placeholder() {
      return React.createElement(PlaceholderNavigation, {
        utility: racker,
        primary: !racker
      });
    }
  }, function (rootCatalog) {
    return React.createElement(React.Fragment, null, racker && React.createElement(UtilityNavigation$1, catalogOverrides(rootCatalog)), !racker && React.createElement(PrimaryNavigation$1, catalogOverrides(rootCatalog)));
  }) : null;
});
RootCatalog.displayName = 'RootCatalog';
var Navigation$1 = React.memo(function (props) {
  var session = SessionProvider$1.janusLogin.useSession();

  var user = _.get(session, 'user');

  var racker = useConfigurationValue('racker', props, _.some(_.get(user, 'roles'), {
    name: 'Racker'
  }));
  var locale = useConfigurationValue('locale', props, 'en-US');
  var catalogOverrides = useConfigurationValue('catalogOverrides', props, _.identity);
  var rackspaceAccountNumber = useConfigurationValue('rackspaceAccountNumber', props, _.get(user, 'RAX-AUTH:domainId'));

  var userId = _.get(user, 'id');

  return React.createElement(React.Fragment, null, React.createElement(Pilot, {
    racker: racker
  }), React.createElement(RootCatalog, {
    userId: userId,
    racker: racker,
    catalogOverrides: catalogOverrides,
    locale: locale
  }), React.createElement(ContextCatalog, {
    userId: userId,
    racker: racker,
    catalogOverrides: catalogOverrides,
    rackspaceAccountNumber: rackspaceAccountNumber,
    locale: locale
  }));
});
Navigation$1.displayName = 'Navigation';
var ApplicationContent = function ApplicationContent(_ref4) {
  var children = _ref4.children;
  return children || null;
};
ApplicationContent.displayName = 'ApplicationContent';
var ApplicationContainer = function ApplicationContainer(props) {
  var configuration = useConfiguration(props);
  return React.createElement(ConfigurationProvider, _extends({
    useJanusLogin: true
  }, configuration), React.createElement(ErrorBoundary, null, React.createElement(SessionProvider$1.janusLogin.SessionProvider, null, React.createElement(ActivityProvider$1.janusLogin.ActivityProvider, null, React.createElement(Navigation$1, props), React.createElement(ApplicationContent, props)))));
};
ApplicationContainer.displayName = 'ApplicationContainer';
ApplicationContainer.defaultProps = {
  catalogOverrides: _.identity
};
var FanaticGuyLogo = function FanaticGuyLogo(_ref5) {
  var children = _ref5.children;
  return React.createElement("div", {
    className: "fanatic-guy-splash"
  }, React.createElement("div", {
    className: "fanatic-guy-splash__logo"
  }), React.createElement("div", {
    className: "fanatic-guy-splash__message"
  }, children));
};
FanaticGuyLogo.displayName = 'FanaticGuyLogo';
var LoadingIndicator = function LoadingIndicator(_ref6) {
  var children = _ref6.children;
  return React.createElement("div", {
    className: "loading-splash"
  }, React.createElement("div", {
    className: "loading-splash__logo"
  }), React.createElement("div", {
    className: "loading-splash__message"
  }, children));
};
LoadingIndicator.displayName = 'LoadingIndicator';
var Authenticating = function Authenticating(_ref7) {
  var children = _ref7.children;
  var session = SessionProvider$1.janusLogin.useSession();
  return !_.get(session, 'user') ? children : null;
};
Authenticating.displayName = 'Authenticating';
var Ready = function Ready(_ref8) {
  var children = _ref8.children;
  var session = SessionProvider$1.janusLogin.useSession();
  return _.get(session, 'user') ? children : null;
};
Ready.displayName = 'Ready';
ApplicationContainer.Authenticating = Authenticating;
ApplicationContainer.Ready = Ready;
ApplicationContainer.FanaticGuyLogo = FanaticGuyLogo;
ApplicationContainer.LoadingIndicator = LoadingIndicator;

var janusLogin$3 = /*#__PURE__*/Object.freeze({
  Navigation: Navigation$1,
  ApplicationContent: ApplicationContent,
  ApplicationContainer: ApplicationContainer,
  FanaticGuyLogo: FanaticGuyLogo,
  LoadingIndicator: LoadingIndicator,
  Authenticating: Authenticating,
  Ready: Ready,
  default: ApplicationContainer
});

var Pilot$1 = React.memo(function (_ref) {
  var racker = _ref.racker,
      _ref$useJanusLogin = _ref.useJanusLogin,
      useJanusLogin = _ref$useJanusLogin === void 0 ? false : _ref$useJanusLogin;
  return racker ? null : React.createElement(UtilityNavigation$1, {
    useJanusLogin: useJanusLogin
  });
});
Pilot$1.displayName = 'Pilot';
var ContextCatalog$1 = React.memo(function (_ref2) {
  var userId = _ref2.userId,
      racker = _ref2.racker,
      catalogOverrides = _ref2.catalogOverrides,
      rackspaceAccountNumber = _ref2.rackspaceAccountNumber,
      locale = _ref2.locale;
  return userId ? rackspaceAccountNumber && racker ? React.createElement(Catalog, {
    live: true,
    locale: locale,
    userId: userId,
    placeholder: function placeholder() {
      return React.createElement(PlaceholderNavigation, {
        context: true,
        primary: true
      });
    }
  }, function (contextCatalog) {
    return React.createElement(React.Fragment, null, React.createElement(ContextNavigation$1, catalogOverrides(contextCatalog)), React.createElement(PrimaryNavigation$1, catalogOverrides(contextCatalog)));
  }) : null : null;
});
ContextCatalog$1.displayName = 'ContextCatalog';
var RootCatalog$1 = React.memo(function (_ref3) {
  var userId = _ref3.userId,
      racker = _ref3.racker,
      catalogOverrides = _ref3.catalogOverrides,
      locale = _ref3.locale;
  return userId ? React.createElement(Catalog, {
    live: true,
    root: true,
    locale: locale,
    userId: userId,
    placeholder: function placeholder() {
      return React.createElement(PlaceholderNavigation, {
        utility: racker,
        primary: !racker
      });
    }
  }, function (rootCatalog) {
    return React.createElement(React.Fragment, null, racker && React.createElement(UtilityNavigation$1, catalogOverrides(rootCatalog)), !racker && React.createElement(PrimaryNavigation$1, catalogOverrides(rootCatalog)));
  }) : null;
});
RootCatalog$1.displayName = 'RootCatalog';
var Navigation$2 = React.memo(function (props) {
  var janusUiSession = React.useContext(context.session);
  var janusLoginSession = SessionProvider$1.janusLogin.useSession();

  var user = _.get(janusLoginSession, 'user') || _.get(janusUiSession, 'session.user');

  var racker = useConfigurationValue('racker', props, _.some(_.get(user, 'roles'), {
    name: 'Racker'
  }));
  var locale = useConfigurationValue('locale', props, 'en-US');
  var catalogOverrides = useConfigurationValue('catalogOverrides', props, _.identity);
  var rackspaceAccountNumber = useConfigurationValue('rackspaceAccountNumber', props, _.get(user, 'RAX-AUTH:domainId'));

  var userId = _.get(user, 'id');

  return React.createElement(React.Fragment, null, React.createElement(Pilot$1, _extends({
    racker: racker
  }, props)), React.createElement(RootCatalog$1, {
    userId: userId,
    racker: racker,
    catalogOverrides: catalogOverrides,
    locale: locale
  }), React.createElement(ContextCatalog$1, {
    userId: userId,
    racker: racker,
    catalogOverrides: catalogOverrides,
    rackspaceAccountNumber: rackspaceAccountNumber,
    locale: locale
  }));
});
Navigation$2.displayName = 'Navigation';
var ApplicationContent$1 = function ApplicationContent$$1(_ref4) {
  var children = _ref4.children;
  return children || null;
};
ApplicationContent$1.displayName = 'ApplicationContent';
var ApplicationContainer$1 = function ApplicationContainer$$1(props) {
  var configuration = useConfiguration(props);

  var useJanusLogin = _.get(configuration, 'useJanusLogin', false);

  var ActivityProviderComponent = useJanusLogin ? ActivityProvider$1.janusLogin.ActivityProvider : ActivityProvider$1;
  var SessionProviderComponent = useJanusLogin ? SessionProvider$1.janusLogin.SessionProvider : SessionProvider$1;
  return React.createElement(ConfigurationProvider, configuration, React.createElement(ErrorBoundary, null, React.createElement(SessionProviderComponent, null, React.createElement(ActivityProviderComponent, null, React.createElement(Navigation$2, props), React.createElement(ApplicationContent$1, props)))));
};
ApplicationContainer$1.displayName = 'ApplicationContainer';
ApplicationContainer$1.defaultProps = {
  catalogOverrides: _.identity
};
var FanaticGuyLogo$1 = function FanaticGuyLogo$$1(_ref5) {
  var children = _ref5.children;
  return React.createElement("div", {
    className: "fanatic-guy-splash"
  }, React.createElement("div", {
    className: "fanatic-guy-splash__logo"
  }), React.createElement("div", {
    className: "fanatic-guy-splash__message"
  }, children));
};
FanaticGuyLogo$1.displayName = 'FanaticGuyLogo';
var LoadingIndicator$1 = function LoadingIndicator$$1(_ref6) {
  var children = _ref6.children;
  return React.createElement("div", {
    className: "loading-splash"
  }, React.createElement("div", {
    className: "loading-splash__logo"
  }), React.createElement("div", {
    className: "loading-splash__message"
  }, children));
};
LoadingIndicator$1.displayName = 'LoadingIndicator';
var Authenticating$1 = function Authenticating$$1(_ref7) {
  var children = _ref7.children;

  var _ref8 = React.useContext(context.session) || {},
      session = _ref8.session;

  return !_.get(session, 'user') ? children : null;
};
Authenticating$1.displayName = 'Authenticating';
var Ready$1 = function Ready$$1(_ref9) {
  var children = _ref9.children;

  var _ref10 = React.useContext(context.session) || {},
      session = _ref10.session;

  return _.get(session, 'user') ? children : null;
};
Ready$1.displayName = 'Ready';
ApplicationContainer$1.Authenticating = Authenticating$1;
ApplicationContainer$1.Ready = Ready$1;
ApplicationContainer$1.FanaticGuyLogo = FanaticGuyLogo$1;
ApplicationContainer$1.LoadingIndicator = LoadingIndicator$1;
ApplicationContainer$1.janusLogin = janusLogin$3;

var prod$1 = function prod() {
  return {};
};

var local = function local() {
  return {
    awsUsageUrl: 'https://dev.manage.rackspace.com/usage/aws'
  };
};

var targetEnvironment = function targetEnvironment() {
  return "aws" || process.env.REACT_APP_TARGET_ENVIRONMENT;
};

var packageName = function packageName() {
  return "@janus.team/janus-copilot" || process.env.REACT_APP_PACKAGE_NAME;
};

var packageVersion = function packageVersion() {
  return "3.3.2" || process.env.REACT_APP_PACKAGE_VERSION;
};

var sha = function sha() {
  return "d838a16bc3a184fa3d534d03735c51cac2b0a6aa" || process.env.REACT_APP_SHA;
};

var base = function base() {
  return {
    serviceLevelIdAviatorNoResell: 'a762359472c94935a8f7c4384a6bee0a',
    meta: {
      name: packageName(),
      version: packageVersion(),
      sha: sha(),
      targetEnvironment: targetEnvironment()
    }
  };
};

var target = function target() {
  return "aws" || process.env.REACT_APP_TARGET_ENVIRONMENT;
};

var all = _.memoize(function () {
  return _.merge(base(), _.invoke({
    aws: prod$1,
    local: local
  }, target()));
});
var env$1 = function env(key, defaultValue) {
  return key ? _.get(all(), key, defaultValue) : all();
};

var meta = env$1('meta');

var addNavigationLinksByRel = function addNavigationLinksByRel(navigation) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        catalog = _ref.catalog;

    var relMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var links = _.get(catalog, "catalog.".concat(navigation, "Navigation.links")) || [];

    var newLinks = _.reduce(relMap, function (result, link, rel) {
      var existing = _.find(links, {
        rel: rel
      });

      var toBeAdded = existing ? [] : [link];

      _.merge(existing, link);

      return [].concat(_toConsumableArray(result), toBeAdded);
    }, []);

    _.forEach(newLinks, function (newLink) {
      return links.push(newLink);
    });

    return {
      catalog: catalog
    };
  };
};

var mergeNavigationLinksByRel = function mergeNavigationLinksByRel(navigation) {
  return function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        catalog = _ref2.catalog;

    var relMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return {
      catalog: _.merge(catalog, {
        catalog: _defineProperty({}, "".concat(navigation, "Navigation"), {
          links: _.map(_.get(catalog, "catalog.".concat(navigation, "Navigation.links")), function (link) {
            return _.merge({}, link, _.get(relMap, _.get(link, 'rel', {})));
          })
        })
      })
    };
  };
};

var addPrimaryNavigationLinksByRel = addNavigationLinksByRel('primary');
var addUtilityNavigationLinksByRel = addNavigationLinksByRel('utility');
var addContextNavigationLinksByRel = addNavigationLinksByRel('context');
var mergePrimaryNavigationLinksByRel = mergeNavigationLinksByRel('primary');
var mergeUtilityNavigationLinksByRel = mergeNavigationLinksByRel('utility');
var mergeContextNavigationLinksByRel = mergeNavigationLinksByRel('context');
var CoPilot = {
  ActivityProvider: ActivityProvider$1,
  ApplicationContainer: ApplicationContainer$1,
  Catalog: Catalog,
  ConfigurationProvider: ConfigurationProvider,
  ContextNavigation: ContextNavigation$1,
  NavigationContextProvider: NavigationContextProvider,
  PlaceholderNavigation: PlaceholderNavigation,
  PrimaryNavigation: PrimaryNavigation$1,
  SessionProvider: SessionProvider$1,
  UtilityNavigation: UtilityNavigation$1,
  catalogKey: catalogKey,
  configMemoizedMergeResult: memoizedMergeResult,
  context: context,
  copilotDocument: copilotDocument,
  copilotLocation: copilotLocation,
  addContextNavigationLinksByRel: addContextNavigationLinksByRel,
  addPrimaryNavigationLinksByRel: addPrimaryNavigationLinksByRel,
  addUtilityNavigationLinksByRel: addUtilityNavigationLinksByRel,
  mergeContextNavigationLinksByRel: mergeContextNavigationLinksByRel,
  mergePrimaryNavigationLinksByRel: mergePrimaryNavigationLinksByRel,
  mergeUtilityNavigationLinksByRel: mergeUtilityNavigationLinksByRel,
  meta: meta,
  proxyFetch: proxyFetch$1
};

export default CoPilot;
export { ActivityProvider$1 as ActivityProvider, ApplicationContainer$1 as ApplicationContainer, Catalog, ConfigurationProvider, ContextNavigation$1 as ContextNavigation, NavigationContextProvider, PlaceholderNavigation, PrimaryNavigation$1 as PrimaryNavigation, SessionProvider$1 as SessionProvider, UtilityNavigation$1 as UtilityNavigation, catalogKey, memoizedMergeResult as configMemoizedMergeResult, context, copilotDocument, copilotLocation, proxyFetch$1 as proxyFetch, meta, addPrimaryNavigationLinksByRel, addUtilityNavigationLinksByRel, addContextNavigationLinksByRel, mergePrimaryNavigationLinksByRel, mergeUtilityNavigationLinksByRel, mergeContextNavigationLinksByRel, CoPilot };
